/*!
  * Bootstrap v5.3.0 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self1) {
    if (self1 === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self1;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self1, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self1);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).bootstrap = e();
}(this, function() {
    "use strict";
    var _instance, _instance1;
    var t = new Map, e = {
        set: function(e, i, n) {
            t.has(e) || t.set(e, new Map);
            var s = t.get(e);
            s.has(i) || 0 === s.size ? s.set(i, n) : console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(s.keys())[0], "."));
        },
        get: function(e, i) {
            return t.has(e) && t.get(e).get(i) || null;
        },
        remove: function(e, i) {
            if (!t.has(e)) return;
            var n = t.get(e);
            n.delete(i), 0 === n.size && t.delete(e);
        }
    }, i = "transitionend", n = function(t) {
        return t && window.CSS && window.CSS.escape && (t = t.replace(/#([^\s"#']+)/g, function(t, e) {
            return "#".concat(CSS.escape(e));
        })), t;
    }, s = function(t) {
        t.dispatchEvent(new Event(i));
    }, o = function(t) {
        return !(!t || "object" != typeof t) && (void 0 !== t.jquery && (t = t[0]), void 0 !== t.nodeType);
    }, r = function(t) {
        return o(t) ? t.jquery ? t[0] : t : "string" == typeof t && t.length > 0 ? document.querySelector(n(t)) : null;
    }, a = function(t) {
        if (!o(t) || 0 === t.getClientRects().length) return !1;
        var e = "visible" === getComputedStyle(t).getPropertyValue("visibility"), i = t.closest("details:not([open])");
        if (!i) return e;
        if (i !== t) {
            var e1 = t.closest("summary");
            if (e1 && e1.parentNode !== i) return !1;
            if (null === e1) return !1;
        }
        return e;
    }, l = function(t) {
        return !t || t.nodeType !== Node.ELEMENT_NODE || !!t.classList.contains("disabled") || (void 0 !== t.disabled ? t.disabled : t.hasAttribute("disabled") && "false" !== t.getAttribute("disabled"));
    }, c = function(t) {
        if (!document.documentElement.attachShadow) return null;
        if ("function" == typeof t.getRootNode) {
            var e = t.getRootNode();
            return e instanceof ShadowRoot ? e : null;
        }
        return t instanceof ShadowRoot ? t : t.parentNode ? c(t.parentNode) : null;
    }, h = function() {}, d = function(t) {
        t.offsetHeight;
    }, u = function() {
        return window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null;
    }, f = [], p = function() {
        return "rtl" === document.documentElement.dir;
    }, m = function(t) {
        var e;
        e = function() {
            var e = u();
            if (e) {
                var i = t.NAME, n = e.fn[i];
                e.fn[i] = t.jQueryInterface, e.fn[i].Constructor = t, e.fn[i].noConflict = function() {
                    return e.fn[i] = n, t.jQueryInterface;
                };
            }
        }, "loading" === document.readyState ? (f.length || document.addEventListener("DOMContentLoaded", function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = f[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var t = _step.value;
                    t();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }), f.push(e)) : e();
    }, g = function(t) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t;
        return "function" == typeof t ? t.apply(void 0, _to_consumable_array(e)) : i;
    }, _ = function(t, e) {
        var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
        if (!n) return void g(t);
        var o = function(t) {
            if (!t) return 0;
            var _window_getComputedStyle = window.getComputedStyle(t), _$e = _window_getComputedStyle.transitionDuration, i = _window_getComputedStyle.transitionDelay;
            var n = Number.parseFloat(_$e), s = Number.parseFloat(i);
            return n || s ? (_$e = _$e.split(",")[0], i = i.split(",")[0], 1e3 * (Number.parseFloat(_$e) + Number.parseFloat(i))) : 0;
        }(e) + 5;
        var r = !1;
        var a = function(param) {
            var n = param.target;
            n === e && (r = !0, e.removeEventListener(i, a), g(t));
        };
        e.addEventListener(i, a), setTimeout(function() {
            r || s(e);
        }, o);
    }, b = function(t, e, i, n) {
        var s = t.length;
        var o = t.indexOf(e);
        return -1 === o ? !i && n ? t[s - 1] : t[0] : (o += i ? 1 : -1, n && (o = (o + s) % s), t[Math.max(0, Math.min(o, s - 1))]);
    }, v = /[^.]*(?=\..*)\.|.*/, y = /\..*/, w = /::\d+$/, A = {};
    var E = 1;
    var T = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    }, C = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    function O(t, e) {
        return e && "".concat(e, "::").concat(E++) || t.uidEvent || E++;
    }
    function x(t) {
        var e = O(t);
        return t.uidEvent = e, A[e] = A[e] || {}, A[e];
    }
    function k(t, e) {
        var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        return Object.values(t).find(function(t) {
            return t.callable === e && t.delegationSelector === i;
        });
    }
    function L(t, e, i) {
        var n = "string" == typeof e, s = n ? i : e || i;
        var o = N(t);
        return C.has(o) || (o = t), [
            n,
            s,
            o
        ];
    }
    function S(t, e, i, n, s) {
        if ("string" != typeof e || !t) return;
        var _L = _sliced_to_array(L(e, i, n), 3), o = _L[0], r = _L[1], a = _L[2];
        if (e in T) {
            var _$t = function(t) {
                return function t1(e) {
                    if (!e.relatedTarget || e.relatedTarget !== e.delegateTarget && !e.delegateTarget.contains(e.relatedTarget)) return t.call(this, e);
                };
            };
            r = _$t(r);
        }
        var l = x(t), c = l[a] || (l[a] = {}), h = k(c, r, o ? i : null);
        if (h) return void (h.oneOff = h.oneOff && s);
        var d = O(r, e.replace(v, "")), u = o ? function(t, e, i) {
            return function n(s) {
                var o = t.querySelectorAll(e);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                for(var r = s.target; r && r !== this; r = r.parentNode)try {
                    for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var a = _step.value;
                        if (a === r) return M(s, {
                            delegateTarget: r
                        }), n.oneOff && P.off(t, s.type, e, i), i.apply(r, [
                            s
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
        }(t, i, r) : function(t, e) {
            return function i(n) {
                return M(n, {
                    delegateTarget: t
                }), i.oneOff && P.off(t, n.type, e), e.apply(t, [
                    n
                ]);
            };
        }(t, r);
        u.delegationSelector = o ? i : null, u.callable = r, u.oneOff = s, u.uidEvent = d, c[d] = u, t.addEventListener(a, u, o);
    }
    function D(t, e, i, n, s) {
        var o = k(e[i], n, s);
        o && (t.removeEventListener(i, o, Boolean(s)), delete e[i][o.uidEvent]);
    }
    function I(t, e, i, n) {
        var s = e[i] || {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(s)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), o = _step_value[0], r = _step_value[1];
                o.includes(n) && D(t, e, i, r.callable, r.delegationSelector);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function N(t) {
        return t = t.replace(y, ""), T[t] || t;
    }
    var P = {
        on: function(t, e, i, n) {
            S(t, e, i, n, !1);
        },
        one: function(t, e, i, n) {
            S(t, e, i, n, !0);
        },
        off: function(t, e, i, n) {
            if ("string" != typeof e || !t) return;
            var _L = _sliced_to_array(L(e, i, n), 3), s = _L[0], o = _L[1], r = _L[2], a = r !== e, l = x(t), c = l[r] || {}, h = e.startsWith(".");
            if (void 0 === o) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (h) try {
                    for(var _iterator = Object.keys(l)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$i = _step.value;
                        I(t, l, _$i, e.slice(1));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = Object.entries(c)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value = _sliced_to_array(_step1.value, 2), _$i1 = _step_value[0], _$n = _step_value[1];
                        var s1 = _$i1.replace(w, "");
                        a && !e.includes(s1) || D(t, l, r, _$n.callable, _$n.delegationSelector);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            } else {
                if (!Object.keys(c).length) return;
                D(t, l, r, o, s ? i : null);
            }
        },
        trigger: function(t, e, i) {
            if ("string" != typeof e || !t) return null;
            var n = u();
            var s = null, o = !0, r = !0, a = !1;
            e !== N(e) && n && (s = n.Event(e, i), n(t).trigger(s), o = !s.isPropagationStopped(), r = !s.isImmediatePropagationStopped(), a = s.isDefaultPrevented());
            var l = M(new Event(e, {
                bubbles: o,
                cancelable: !0
            }), i);
            return a && l.preventDefault(), r && t.dispatchEvent(l), l.defaultPrevented && s && s.preventDefault(), l;
        }
    };
    function M(t) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _step_value = _sliced_to_array(_step.value, 2), i = _step_value[0], n = _step_value[1];
                try {
                    t[i] = n;
                } catch (e) {
                    Object.defineProperty(t, i, {
                        configurable: !0,
                        get: function() {
                            return n;
                        }
                    });
                }
            };
            for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return t;
    }
    function j(t) {
        if ("true" === t) return !0;
        if ("false" === t) return !1;
        if (t === Number(t).toString()) return Number(t);
        if ("" === t || "null" === t) return null;
        if ("string" != typeof t) return t;
        try {
            return JSON.parse(decodeURIComponent(t));
        } catch (e) {
            return t;
        }
    }
    function F(t) {
        return t.replace(/[A-Z]/g, function(t) {
            return "-".concat(t.toLowerCase());
        });
    }
    var H = {
        setDataAttribute: function(t, e, i) {
            t.setAttribute("data-bs-".concat(F(e)), i);
        },
        removeDataAttribute: function(t, e) {
            t.removeAttribute("data-bs-".concat(F(e)));
        },
        getDataAttributes: function(t) {
            if (!t) return {};
            var e = {}, i = Object.keys(t.dataset).filter(function(t) {
                return t.startsWith("bs") && !t.startsWith("bsConfig");
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    var i1 = n.replace(/^bs/, "");
                    i1 = i1.charAt(0).toLowerCase() + i1.slice(1, i1.length), e[i1] = j(t.dataset[n]);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return e;
        },
        getDataAttribute: function(t, e) {
            return j(t.getAttribute("data-bs-".concat(F(e))));
        }
    };
    var $ = /*#__PURE__*/ function() {
        function $() {
            _class_call_check(this, $);
        }
        _create_class($, [
            {
                key: "_getConfig",
                value: function _getConfig(t) {
                    return t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(t) {
                    return t;
                }
            },
            {
                key: "_mergeConfigObj",
                value: function _mergeConfigObj(t, e) {
                    var i = o(e) ? H.getDataAttribute(e, "config") : {};
                    return _object_spread({}, this.constructor.Default, "object" == typeof i ? i : {}, o(e) ? H.getDataAttributes(e) : {}, "object" == typeof t ? t : {});
                }
            },
            {
                key: "_typeCheckConfig",
                value: function _typeCheckConfig(t) {
                    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _sliced_to_array(_step.value, 2), n = _step_value[0], s = _step_value[1];
                            var e1 = t[n], r = o(e1) ? "element" : null == (i = e1) ? "".concat(i) : Object.prototype.toString.call(i).match(/\s([a-z]+)/i)[1].toLowerCase();
                            if (!new RegExp(s).test(r)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(n, '" provided type "').concat(r, '" but expected type "').concat(s, '".'));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var i;
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return {};
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return {};
                }
            },
            {
                key: "NAME",
                get: function get() {
                    throw new Error('You have to implement the static method "NAME", for each component!');
                }
            }
        ]);
        return $;
    }();
    var W = /*#__PURE__*/ function($) {
        _inherits(W, $);
        var _super = _create_super(W);
        function W(t, i) {
            _class_call_check(this, W);
            var _this;
            _this = _super.call(this), (t = r(t)) && (_this._element = t, _this._config = _this._getConfig(i), e.set(_this._element, _this.constructor.DATA_KEY, _assert_this_initialized(_this)));
            return _possible_constructor_return(_this);
        }
        _create_class(W, [
            {
                key: "dispose",
                value: function dispose() {
                    e.remove(this._element, this.constructor.DATA_KEY), P.off(this._element, this.constructor.EVENT_KEY);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t = _step.value;
                            this[t] = null;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_queueCallback",
                value: function _queueCallback(t, e) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                    _(t, e, i);
                }
            },
            {
                key: "_getConfig",
                value: function _getConfig(t) {
                    return t = this._mergeConfigObj(t, this._element), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
                }
            }
        ], [
            {
                key: "getInstance",
                value: function getInstance(t) {
                    return e.get(r(t), this.DATA_KEY);
                }
            },
            {
                key: "getOrCreateInstance",
                value: function getOrCreateInstance(t) {
                    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return this.getInstance(t) || new this(t, "object" == typeof e ? e : null);
                }
            },
            {
                key: "VERSION",
                get: function get() {
                    return "5.3.0";
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return "bs.".concat(this.NAME);
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return ".".concat(this.DATA_KEY);
                }
            },
            {
                key: "eventName",
                value: function eventName(t) {
                    return "".concat(t).concat(this.EVENT_KEY);
                }
            }
        ]);
        return W;
    }($);
    var B = function(t) {
        var e = t.getAttribute("data-bs-target");
        if (!e || "#" === e) {
            var i = t.getAttribute("href");
            if (!i || !i.includes("#") && !i.startsWith(".")) return null;
            i.includes("#") && !i.startsWith("#") && (i = "#".concat(i.split("#")[1])), e = i && "#" !== i ? i.trim() : null;
        }
        return n(e);
    }, z = {
        find: function(t) {
            var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
            return (_instance = []).concat.apply(_instance, _to_consumable_array(Element.prototype.querySelectorAll.call(e, t)));
        },
        findOne: function(t) {
            var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
            return Element.prototype.querySelector.call(e, t);
        },
        children: function(t, e) {
            return (_instance1 = []).concat.apply(_instance1, _to_consumable_array(t.children)).filter(function(t) {
                return t.matches(e);
            });
        },
        parents: function(t, e) {
            var i = [];
            var n = t.parentNode.closest(e);
            for(; n;)i.push(n), n = n.parentNode.closest(e);
            return i;
        },
        prev: function(t, e) {
            var i = t.previousElementSibling;
            for(; i;){
                if (i.matches(e)) return [
                    i
                ];
                i = i.previousElementSibling;
            }
            return [];
        },
        next: function(t, e) {
            var i = t.nextElementSibling;
            for(; i;){
                if (i.matches(e)) return [
                    i
                ];
                i = i.nextElementSibling;
            }
            return [];
        },
        focusableChildren: function(t) {
            var e = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map(function(t) {
                return "".concat(t, ':not([tabindex^="-"])');
            }).join(",");
            return this.find(e, t).filter(function(t) {
                return !l(t) && a(t);
            });
        },
        getSelectorFromElement: function(t) {
            var e = B(t);
            return e && z.findOne(e) ? e : null;
        },
        getElementFromSelector: function(t) {
            var e = B(t);
            return e ? z.findOne(e) : null;
        },
        getMultipleElementsFromSelector: function(t) {
            var e = B(t);
            return e ? z.find(e) : [];
        }
    }, R = function(t) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "hide";
        var i = "click.dismiss".concat(t.EVENT_KEY), n = t.NAME;
        P.on(document, i, '[data-bs-dismiss="'.concat(n, '"]'), function(i) {
            if ([
                "A",
                "AREA"
            ].includes(this.tagName) && i.preventDefault(), l(this)) return;
            var s = z.getElementFromSelector(this) || this.closest(".".concat(n));
            t.getOrCreateInstance(s)[e]();
        });
    };
    var q = /*#__PURE__*/ function(W) {
        _inherits(q, W);
        var _super = _create_super(q);
        function q() {
            _class_call_check(this, q);
            return _super.apply(this, arguments);
        }
        _create_class(q, [
            {
                key: "close",
                value: function close() {
                    var _this = this;
                    if (P.trigger(this._element, "close.bs.alert").defaultPrevented) return;
                    this._element.classList.remove("show");
                    var t = this._element.classList.contains("fade");
                    this._queueCallback(function() {
                        return _this._destroyElement();
                    }, this._element, t);
                }
            },
            {
                key: "_destroyElement",
                value: function _destroyElement() {
                    this._element.remove(), P.trigger(this._element, "closed.bs.alert"), this.dispose();
                }
            }
        ], [
            {
                key: "NAME",
                get: function get() {
                    return "alert";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = q.getOrCreateInstance(this);
                        if ("string" == typeof t) {
                            if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError('No method named "'.concat(t, '"'));
                            e[t](this);
                        }
                    });
                }
            }
        ]);
        return q;
    }(W);
    R(q, "close"), m(q);
    var V = '[data-bs-toggle="button"]';
    var K = /*#__PURE__*/ function(W) {
        _inherits(K, W);
        var _super = _create_super(K);
        function K() {
            _class_call_check(this, K);
            return _super.apply(this, arguments);
        }
        _create_class(K, [
            {
                key: "toggle",
                value: function toggle() {
                    this._element.setAttribute("aria-pressed", this._element.classList.toggle("active"));
                }
            }
        ], [
            {
                key: "NAME",
                get: function get() {
                    return "button";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = K.getOrCreateInstance(this);
                        "toggle" === t && e[t]();
                    });
                }
            }
        ]);
        return K;
    }(W);
    P.on(document, "click.bs.button.data-api", V, function(t) {
        t.preventDefault();
        var e = t.target.closest(V);
        K.getOrCreateInstance(e).toggle();
    }), m(K);
    var Q = {
        endCallback: null,
        leftCallback: null,
        rightCallback: null
    }, X = {
        endCallback: "(function|null)",
        leftCallback: "(function|null)",
        rightCallback: "(function|null)"
    };
    var Y = /*#__PURE__*/ function($) {
        _inherits(Y, $);
        var _super = _create_super(Y);
        function Y(t, e) {
            _class_call_check(this, Y);
            var _this;
            _this = _super.call(this), _this._element = t, t && Y.isSupported() && (_this._config = _this._getConfig(e), _this._deltaX = 0, _this._supportPointerEvents = Boolean(window.PointerEvent), _this._initEvents());
            return _possible_constructor_return(_this);
        }
        _create_class(Y, [
            {
                key: "dispose",
                value: function dispose() {
                    P.off(this._element, ".bs.swipe");
                }
            },
            {
                key: "_start",
                value: function _start(t) {
                    this._supportPointerEvents ? this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX) : this._deltaX = t.touches[0].clientX;
                }
            },
            {
                key: "_end",
                value: function _end(t) {
                    this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX - this._deltaX), this._handleSwipe(), g(this._config.endCallback);
                }
            },
            {
                key: "_move",
                value: function _move(t) {
                    this._deltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this._deltaX;
                }
            },
            {
                key: "_handleSwipe",
                value: function _handleSwipe() {
                    var t = Math.abs(this._deltaX);
                    if (t <= 40) return;
                    var e = t / this._deltaX;
                    this._deltaX = 0, e && g(e > 0 ? this._config.rightCallback : this._config.leftCallback);
                }
            },
            {
                key: "_initEvents",
                value: function _initEvents() {
                    var _this = this;
                    this._supportPointerEvents ? (P.on(this._element, "pointerdown.bs.swipe", function(t) {
                        return _this._start(t);
                    }), P.on(this._element, "pointerup.bs.swipe", function(t) {
                        return _this._end(t);
                    }), this._element.classList.add("pointer-event")) : (P.on(this._element, "touchstart.bs.swipe", function(t) {
                        return _this._start(t);
                    }), P.on(this._element, "touchmove.bs.swipe", function(t) {
                        return _this._move(t);
                    }), P.on(this._element, "touchend.bs.swipe", function(t) {
                        return _this._end(t);
                    }));
                }
            },
            {
                key: "_eventIsPointerPenTouch",
                value: function _eventIsPointerPenTouch(t) {
                    return this._supportPointerEvents && ("pen" === t.pointerType || "touch" === t.pointerType);
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return Q;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return X;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "swipe";
                }
            },
            {
                key: "isSupported",
                value: function isSupported() {
                    return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
                }
            }
        ]);
        return Y;
    }($);
    var U = "next", G = "prev", J = "left", Z = "right", tt = "slid.bs.carousel", et = "carousel", it = "active", nt = {
        ArrowLeft: Z,
        ArrowRight: J
    }, st = {
        interval: 5e3,
        keyboard: !0,
        pause: "hover",
        ride: !1,
        touch: !0,
        wrap: !0
    }, ot = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        pause: "(string|boolean)",
        ride: "(boolean|string)",
        touch: "boolean",
        wrap: "boolean"
    };
    var rt = /*#__PURE__*/ function(W) {
        _inherits(rt, W);
        var _super = _create_super(rt);
        function rt(t, e) {
            _class_call_check(this, rt);
            var _this;
            _this = _super.call(this, t, e), _this._interval = null, _this._activeElement = null, _this._isSliding = !1, _this.touchTimeout = null, _this._swipeHelper = null, _this._indicatorsElement = z.findOne(".carousel-indicators", _this._element), _this._addEventListeners(), _this._config.ride === et && _this.cycle();
            return _possible_constructor_return(_this);
        }
        _create_class(rt, [
            {
                key: "next",
                value: function next() {
                    this._slide(U);
                }
            },
            {
                key: "nextWhenVisible",
                value: function nextWhenVisible() {
                    !document.hidden && a(this._element) && this.next();
                }
            },
            {
                key: "prev",
                value: function prev() {
                    this._slide(G);
                }
            },
            {
                key: "pause",
                value: function pause() {
                    this._isSliding && s(this._element), this._clearInterval();
                }
            },
            {
                key: "cycle",
                value: function cycle() {
                    var _this = this;
                    this._clearInterval(), this._updateInterval(), this._interval = setInterval(function() {
                        return _this.nextWhenVisible();
                    }, this._config.interval);
                }
            },
            {
                key: "_maybeEnableCycle",
                value: function _maybeEnableCycle() {
                    var _this = this;
                    this._config.ride && (this._isSliding ? P.one(this._element, tt, function() {
                        return _this.cycle();
                    }) : this.cycle());
                }
            },
            {
                key: "to",
                value: function to(t) {
                    var _this = this;
                    var e = this._getItems();
                    if (t > e.length - 1 || t < 0) return;
                    if (this._isSliding) return void P.one(this._element, tt, function() {
                        return _this.to(t);
                    });
                    var i = this._getItemIndex(this._getActive());
                    if (i === t) return;
                    var n = t > i ? U : G;
                    this._slide(n, e[t]);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this._swipeHelper && this._swipeHelper.dispose(), _get(_get_prototype_of(rt.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(t) {
                    return t.defaultInterval = t.interval, t;
                }
            },
            {
                key: "_addEventListeners",
                value: function _addEventListeners() {
                    var _this = this;
                    this._config.keyboard && P.on(this._element, "keydown.bs.carousel", function(t) {
                        return _this._keydown(t);
                    }), "hover" === this._config.pause && (P.on(this._element, "mouseenter.bs.carousel", function() {
                        return _this.pause();
                    }), P.on(this._element, "mouseleave.bs.carousel", function() {
                        return _this._maybeEnableCycle();
                    })), this._config.touch && Y.isSupported() && this._addTouchEventListeners();
                }
            },
            {
                key: "_addTouchEventListeners",
                value: function _addTouchEventListeners() {
                    var _this = this;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = z.find(".carousel-item img", this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t = _step.value;
                            P.on(t, "dragstart.bs.carousel", function(t) {
                                return t.preventDefault();
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var t1 = {
                        leftCallback: function() {
                            return _this._slide(_this._directionToOrder(J));
                        },
                        rightCallback: function() {
                            return _this._slide(_this._directionToOrder(Z));
                        },
                        endCallback: function() {
                            "hover" === _this._config.pause && (_this.pause(), _this.touchTimeout && clearTimeout(_this.touchTimeout), _this.touchTimeout = setTimeout(function() {
                                return _this._maybeEnableCycle();
                            }, 500 + _this._config.interval));
                        }
                    };
                    this._swipeHelper = new Y(this._element, t1);
                }
            },
            {
                key: "_keydown",
                value: function _keydown(t) {
                    if (/input|textarea/i.test(t.target.tagName)) return;
                    var e = nt[t.key];
                    e && (t.preventDefault(), this._slide(this._directionToOrder(e)));
                }
            },
            {
                key: "_getItemIndex",
                value: function _getItemIndex(t) {
                    return this._getItems().indexOf(t);
                }
            },
            {
                key: "_setActiveIndicatorElement",
                value: function _setActiveIndicatorElement(t) {
                    if (!this._indicatorsElement) return;
                    var e = z.findOne(".active", this._indicatorsElement);
                    e.classList.remove(it), e.removeAttribute("aria-current");
                    var i = z.findOne('[data-bs-slide-to="'.concat(t, '"]'), this._indicatorsElement);
                    i && (i.classList.add(it), i.setAttribute("aria-current", "true"));
                }
            },
            {
                key: "_updateInterval",
                value: function _updateInterval() {
                    var t = this._activeElement || this._getActive();
                    if (!t) return;
                    var e = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
                    this._config.interval = e || this._config.defaultInterval;
                }
            },
            {
                key: "_slide",
                value: function _slide(t) {
                    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                    var _this = this;
                    if (this._isSliding) return;
                    var i = this._getActive(), n = t === U, s = e || b(this._getItems(), i, n, this._config.wrap);
                    if (s === i) return;
                    var o = this._getItemIndex(s), r = function(e) {
                        return P.trigger(_this._element, e, {
                            relatedTarget: s,
                            direction: _this._orderToDirection(t),
                            from: _this._getItemIndex(i),
                            to: o
                        });
                    };
                    if (r("slide.bs.carousel").defaultPrevented) return;
                    if (!i || !s) return;
                    var a = Boolean(this._interval);
                    this.pause(), this._isSliding = !0, this._setActiveIndicatorElement(o), this._activeElement = s;
                    var l = n ? "carousel-item-start" : "carousel-item-end", c = n ? "carousel-item-next" : "carousel-item-prev";
                    s.classList.add(c), d(s), i.classList.add(l), s.classList.add(l), this._queueCallback(function() {
                        s.classList.remove(l, c), s.classList.add(it), i.classList.remove(it, c, l), _this._isSliding = !1, r(tt);
                    }, i, this._isAnimated()), a && this.cycle();
                }
            },
            {
                key: "_isAnimated",
                value: function _isAnimated() {
                    return this._element.classList.contains("slide");
                }
            },
            {
                key: "_getActive",
                value: function _getActive() {
                    return z.findOne(".active.carousel-item", this._element);
                }
            },
            {
                key: "_getItems",
                value: function _getItems() {
                    return z.find(".carousel-item", this._element);
                }
            },
            {
                key: "_clearInterval",
                value: function _clearInterval() {
                    this._interval && (clearInterval(this._interval), this._interval = null);
                }
            },
            {
                key: "_directionToOrder",
                value: function _directionToOrder(t) {
                    return p() ? t === J ? G : U : t === J ? U : G;
                }
            },
            {
                key: "_orderToDirection",
                value: function _orderToDirection(t) {
                    return p() ? t === G ? J : Z : t === G ? Z : J;
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return st;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return ot;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "carousel";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = rt.getOrCreateInstance(this, t);
                        if ("number" != typeof t) {
                            if ("string" == typeof t) {
                                if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError('No method named "'.concat(t, '"'));
                                e[t]();
                            }
                        } else e.to(t);
                    });
                }
            }
        ]);
        return rt;
    }(W);
    P.on(document, "click.bs.carousel.data-api", "[data-bs-slide], [data-bs-slide-to]", function(t) {
        var e = z.getElementFromSelector(this);
        if (!e || !e.classList.contains(et)) return;
        t.preventDefault();
        var i = rt.getOrCreateInstance(e), n = this.getAttribute("data-bs-slide-to");
        return n ? (i.to(n), void i._maybeEnableCycle()) : "next" === H.getDataAttribute(this, "slide") ? (i.next(), void i._maybeEnableCycle()) : (i.prev(), void i._maybeEnableCycle());
    }), P.on(window, "load.bs.carousel.data-api", function() {
        var t = z.find('[data-bs-ride="carousel"]');
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                rt.getOrCreateInstance(e);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }), m(rt);
    var at = "show", lt = "collapse", ct = "collapsing", ht = '[data-bs-toggle="collapse"]', dt = {
        parent: null,
        toggle: !0
    }, ut = {
        parent: "(null|element)",
        toggle: "boolean"
    };
    var ft = /*#__PURE__*/ function(W) {
        _inherits(ft, W);
        var _super = _create_super(ft);
        function ft(t, e) {
            _class_call_check(this, ft);
            var _this;
            _this = _super.call(this, t, e), _this._isTransitioning = !1, _this._triggerArray = [];
            var i = z.find(ht);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$t = _step.value;
                    var _$e = z.getSelectorFromElement(_$t), i1 = z.find(_$e).filter(function(t) {
                        return t === _this._element;
                    });
                    null !== _$e && i1.length && _this._triggerArray.push(_$t);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            _this._initializeChildren(), _this._config.parent || _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown()), _this._config.toggle && _this.toggle();
            return _possible_constructor_return(_this);
        }
        _create_class(ft, [
            {
                key: "toggle",
                value: function toggle() {
                    this._isShown() ? this.hide() : this.show();
                }
            },
            {
                key: "show",
                value: function show() {
                    var _this = this;
                    if (this._isTransitioning || this._isShown()) return;
                    var t = [];
                    if (this._config.parent && (t = this._getFirstLevelChildren(".collapse.show, .collapse.collapsing").filter(function(t) {
                        return t !== _this._element;
                    }).map(function(t) {
                        return ft.getOrCreateInstance(t, {
                            toggle: !1
                        });
                    })), t.length && t[0]._isTransitioning) return;
                    if (P.trigger(this._element, "show.bs.collapse").defaultPrevented) return;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var e = _step.value;
                            e.hide();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var e1 = this._getDimension();
                    this._element.classList.remove(lt), this._element.classList.add(ct), this._element.style[e1] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
                    var i = "scroll".concat(e1[0].toUpperCase() + e1.slice(1));
                    this._queueCallback(function() {
                        _this._isTransitioning = !1, _this._element.classList.remove(ct), _this._element.classList.add(lt, at), _this._element.style[e1] = "", P.trigger(_this._element, "shown.bs.collapse");
                    }, this._element, !0), this._element.style[e1] = "".concat(this._element[i], "px");
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    if (this._isTransitioning || !this._isShown()) return;
                    if (P.trigger(this._element, "hide.bs.collapse").defaultPrevented) return;
                    var t = this._getDimension();
                    this._element.style[t] = "".concat(this._element.getBoundingClientRect()[t], "px"), d(this._element), this._element.classList.add(ct), this._element.classList.remove(lt, at);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t1 = _step.value;
                            var e = z.getElementFromSelector(t1);
                            e && !this._isShown(e) && this._addAriaAndCollapsedClass([
                                t1
                            ], !1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._isTransitioning = !0, this._element.style[t] = "", this._queueCallback(function() {
                        _this._isTransitioning = !1, _this._element.classList.remove(ct), _this._element.classList.add(lt), P.trigger(_this._element, "hidden.bs.collapse");
                    }, this._element, !0);
                }
            },
            {
                key: "_isShown",
                value: function _isShown() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                    return t.classList.contains(at);
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(t) {
                    return t.toggle = Boolean(t.toggle), t.parent = r(t.parent), t;
                }
            },
            {
                key: "_getDimension",
                value: function _getDimension() {
                    return this._element.classList.contains("collapse-horizontal") ? "width" : "height";
                }
            },
            {
                key: "_initializeChildren",
                value: function _initializeChildren() {
                    if (!this._config.parent) return;
                    var t = this._getFirstLevelChildren(ht);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var e = _step.value;
                            var t1 = z.getElementFromSelector(e);
                            t1 && this._addAriaAndCollapsedClass([
                                e
                            ], this._isShown(t1));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_getFirstLevelChildren",
                value: function _getFirstLevelChildren(t) {
                    var e = z.find(":scope .collapse .collapse", this._config.parent);
                    return z.find(t, this._config.parent).filter(function(t) {
                        return !e.includes(t);
                    });
                }
            },
            {
                key: "_addAriaAndCollapsedClass",
                value: function _addAriaAndCollapsedClass(t, e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (t.length) try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            i.classList.toggle("collapsed", !e), i.setAttribute("aria-expanded", e);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return dt;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return ut;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "collapse";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    var e = {};
                    return "string" == typeof t && /show|hide/.test(t) && (e.toggle = !1), this.each(function() {
                        var i = ft.getOrCreateInstance(this, e);
                        if ("string" == typeof t) {
                            if (void 0 === i[t]) throw new TypeError('No method named "'.concat(t, '"'));
                            i[t]();
                        }
                    });
                }
            }
        ]);
        return ft;
    }(W);
    P.on(document, "click.bs.collapse.data-api", ht, function(t) {
        ("A" === t.target.tagName || t.delegateTarget && "A" === t.delegateTarget.tagName) && t.preventDefault();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = z.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$t = _step.value;
                ft.getOrCreateInstance(_$t, {
                    toggle: !1
                }).toggle();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }), m(ft);
    var pt = "top", mt = "bottom", gt = "right", _t = "left", bt = "auto", vt = [
        pt,
        mt,
        gt,
        _t
    ], yt = "start", wt = "end", At = "clippingParents", Et = "viewport", Tt = "popper", Ct = "reference", Ot = vt.reduce(function(t, e) {
        return t.concat([
            e + "-" + yt,
            e + "-" + wt
        ]);
    }, []), xt = [].concat(vt, [
        bt
    ]).reduce(function(t, e) {
        return t.concat([
            e,
            e + "-" + yt,
            e + "-" + wt
        ]);
    }, []), kt = "beforeRead", Lt = "read", St = "afterRead", Dt = "beforeMain", It = "main", Nt = "afterMain", Pt = "beforeWrite", Mt = "write", jt = "afterWrite", Ft = [
        kt,
        Lt,
        St,
        Dt,
        It,
        Nt,
        Pt,
        Mt,
        jt
    ];
    function Ht(t) {
        return t ? (t.nodeName || "").toLowerCase() : null;
    }
    function $t(t) {
        if (null == t) return window;
        if ("[object Window]" !== t.toString()) {
            var e = t.ownerDocument;
            return e && e.defaultView || window;
        }
        return t;
    }
    function Wt(t) {
        return t instanceof $t(t).Element || t instanceof Element;
    }
    function Bt(t) {
        return t instanceof $t(t).HTMLElement || t instanceof HTMLElement;
    }
    function zt(t) {
        return "undefined" != typeof ShadowRoot && (t instanceof $t(t).ShadowRoot || t instanceof ShadowRoot);
    }
    var Rt = {
        name: "applyStyles",
        enabled: !0,
        phase: "write",
        fn: function fn(t) {
            var e = t.state;
            Object.keys(e.elements).forEach(function(t) {
                var i = e.styles[t] || {}, n = e.attributes[t] || {}, s = e.elements[t];
                Bt(s) && Ht(s) && (Object.assign(s.style, i), Object.keys(n).forEach(function(t) {
                    var e = n[t];
                    !1 === e ? s.removeAttribute(t) : s.setAttribute(t, !0 === e ? "" : e);
                }));
            });
        },
        effect: function effect(t) {
            var e = t.state, i = {
                popper: {
                    position: e.options.strategy,
                    left: "0",
                    top: "0",
                    margin: "0"
                },
                arrow: {
                    position: "absolute"
                },
                reference: {}
            };
            return Object.assign(e.elements.popper.style, i.popper), e.styles = i, e.elements.arrow && Object.assign(e.elements.arrow.style, i.arrow), function() {
                Object.keys(e.elements).forEach(function(t) {
                    var n = e.elements[t], s = e.attributes[t] || {}, o = Object.keys(e.styles.hasOwnProperty(t) ? e.styles[t] : i[t]).reduce(function(t, e) {
                        return t[e] = "", t;
                    }, {});
                    Bt(n) && Ht(n) && (Object.assign(n.style, o), Object.keys(s).forEach(function(t) {
                        n.removeAttribute(t);
                    }));
                });
            };
        },
        requires: [
            "computeStyles"
        ]
    };
    function qt(t) {
        return t.split("-")[0];
    }
    var Vt = Math.max, Kt = Math.min, Qt = Math.round;
    function Xt() {
        var t = navigator.userAgentData;
        return null != t && t.brands && Array.isArray(t.brands) ? t.brands.map(function(t) {
            return t.brand + "/" + t.version;
        }).join(" ") : navigator.userAgent;
    }
    function Yt() {
        return !/^((?!chrome|android).)*safari/i.test(Xt());
    }
    function Ut(t, e, i) {
        void 0 === e && (e = !1), void 0 === i && (i = !1);
        var n = t.getBoundingClientRect(), s = 1, o = 1;
        e && Bt(t) && (s = t.offsetWidth > 0 && Qt(n.width) / t.offsetWidth || 1, o = t.offsetHeight > 0 && Qt(n.height) / t.offsetHeight || 1);
        var r = (Wt(t) ? $t(t) : window).visualViewport, a = !Yt() && i, l = (n.left + (a && r ? r.offsetLeft : 0)) / s, c = (n.top + (a && r ? r.offsetTop : 0)) / o, h = n.width / s, d = n.height / o;
        return {
            width: h,
            height: d,
            top: c,
            right: l + h,
            bottom: c + d,
            left: l,
            x: l,
            y: c
        };
    }
    function Gt(t) {
        var e = Ut(t), i = t.offsetWidth, n = t.offsetHeight;
        return Math.abs(e.width - i) <= 1 && (i = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
            x: t.offsetLeft,
            y: t.offsetTop,
            width: i,
            height: n
        };
    }
    function Jt(t, e) {
        var i = e.getRootNode && e.getRootNode();
        if (t.contains(e)) return !0;
        if (i && zt(i)) {
            var n = e;
            do {
                if (n && t.isSameNode(n)) return !0;
                n = n.parentNode || n.host;
            }while (n);
        }
        return !1;
    }
    function Zt(t) {
        return $t(t).getComputedStyle(t);
    }
    function te(t) {
        return [
            "table",
            "td",
            "th"
        ].indexOf(Ht(t)) >= 0;
    }
    function ee(t) {
        return ((Wt(t) ? t.ownerDocument : t.document) || window.document).documentElement;
    }
    function ie(t) {
        return "html" === Ht(t) ? t : t.assignedSlot || t.parentNode || (zt(t) ? t.host : null) || ee(t);
    }
    function ne(t) {
        return Bt(t) && "fixed" !== Zt(t).position ? t.offsetParent : null;
    }
    function se(t) {
        for(var e = $t(t), i = ne(t); i && te(i) && "static" === Zt(i).position;)i = ne(i);
        return i && ("html" === Ht(i) || "body" === Ht(i) && "static" === Zt(i).position) ? e : i || function(t) {
            var e = /firefox/i.test(Xt());
            if (/Trident/i.test(Xt()) && Bt(t) && "fixed" === Zt(t).position) return null;
            var i = ie(t);
            for(zt(i) && (i = i.host); Bt(i) && [
                "html",
                "body"
            ].indexOf(Ht(i)) < 0;){
                var n = Zt(i);
                if ("none" !== n.transform || "none" !== n.perspective || "paint" === n.contain || -1 !== [
                    "transform",
                    "perspective"
                ].indexOf(n.willChange) || e && "filter" === n.willChange || e && n.filter && "none" !== n.filter) return i;
                i = i.parentNode;
            }
            return null;
        }(t) || e;
    }
    function oe(t) {
        return [
            "top",
            "bottom"
        ].indexOf(t) >= 0 ? "x" : "y";
    }
    function re(t, e, i) {
        return Vt(t, Kt(e, i));
    }
    function ae(t) {
        return Object.assign({}, {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, t);
    }
    function le(t, e) {
        return e.reduce(function(e, i) {
            return e[i] = t, e;
        }, {});
    }
    var ce = {
        name: "arrow",
        enabled: !0,
        phase: "main",
        fn: function fn(t) {
            var e, i = t.state, n = t.name, s = t.options, o = i.elements.arrow, r = i.modifiersData.popperOffsets, a = qt(i.placement), l = oe(a), c = [
                _t,
                gt
            ].indexOf(a) >= 0 ? "height" : "width";
            if (o && r) {
                var h = function(t, e) {
                    return ae("number" != typeof (t = "function" == typeof t ? t(Object.assign({}, e.rects, {
                        placement: e.placement
                    })) : t) ? t : le(t, vt));
                }(s.padding, i), d = Gt(o), u = "y" === l ? pt : _t, f = "y" === l ? mt : gt, p = i.rects.reference[c] + i.rects.reference[l] - r[l] - i.rects.popper[c], m = r[l] - i.rects.reference[l], g = se(o), _ = g ? "y" === l ? g.clientHeight || 0 : g.clientWidth || 0 : 0, b = p / 2 - m / 2, v = h[u], y = _ - d[c] - h[f], w = _ / 2 - d[c] / 2 + b, A = re(v, w, y), E = l;
                i.modifiersData[n] = ((e = {})[E] = A, e.centerOffset = A - w, e);
            }
        },
        effect: function effect(t) {
            var e = t.state, i = t.options.element, n = void 0 === i ? "[data-popper-arrow]" : i;
            null != n && ("string" != typeof n || (n = e.elements.popper.querySelector(n))) && Jt(e.elements.popper, n) && (e.elements.arrow = n);
        },
        requires: [
            "popperOffsets"
        ],
        requiresIfExists: [
            "preventOverflow"
        ]
    };
    function he(t) {
        return t.split("-")[1];
    }
    var de = {
        top: "auto",
        right: "auto",
        bottom: "auto",
        left: "auto"
    };
    function ue(t) {
        var e, i = t.popper, n = t.popperRect, s = t.placement, o = t.variation, r = t.offsets, a = t.position, l = t.gpuAcceleration, c = t.adaptive, h = t.roundOffsets, d = t.isFixed, u = r.x, f = void 0 === u ? 0 : u, p = r.y, m = void 0 === p ? 0 : p, g = "function" == typeof h ? h({
            x: f,
            y: m
        }) : {
            x: f,
            y: m
        };
        f = g.x, m = g.y;
        var _ = r.hasOwnProperty("x"), b = r.hasOwnProperty("y"), v = _t, y = pt, w = window;
        if (c) {
            var A = se(i), E = "clientHeight", T = "clientWidth";
            A === $t(i) && "static" !== Zt(A = ee(i)).position && "absolute" === a && (E = "scrollHeight", T = "scrollWidth"), (s === pt || (s === _t || s === gt) && o === wt) && (y = mt, m -= (d && A === w && w.visualViewport ? w.visualViewport.height : A[E]) - n.height, m *= l ? 1 : -1), s !== _t && (s !== pt && s !== mt || o !== wt) || (v = gt, f -= (d && A === w && w.visualViewport ? w.visualViewport.width : A[T]) - n.width, f *= l ? 1 : -1);
        }
        var C, O = Object.assign({
            position: a
        }, c && de), x = !0 === h ? function(t, e) {
            var i = t.x, n = t.y, s = e.devicePixelRatio || 1;
            return {
                x: Qt(i * s) / s || 0,
                y: Qt(n * s) / s || 0
            };
        }({
            x: f,
            y: m
        }, $t(i)) : {
            x: f,
            y: m
        };
        return f = x.x, m = x.y, l ? Object.assign({}, O, ((C = {})[y] = b ? "0" : "", C[v] = _ ? "0" : "", C.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + m + "px)" : "translate3d(" + f + "px, " + m + "px, 0)", C)) : Object.assign({}, O, ((e = {})[y] = b ? m + "px" : "", e[v] = _ ? f + "px" : "", e.transform = "", e));
    }
    var fe = {
        name: "computeStyles",
        enabled: !0,
        phase: "beforeWrite",
        fn: function fn(t) {
            var e = t.state, i = t.options, n = i.gpuAcceleration, s = void 0 === n || n, o = i.adaptive, r = void 0 === o || o, a = i.roundOffsets, l = void 0 === a || a, c = {
                placement: qt(e.placement),
                variation: he(e.placement),
                popper: e.elements.popper,
                popperRect: e.rects.popper,
                gpuAcceleration: s,
                isFixed: "fixed" === e.options.strategy
            };
            null != e.modifiersData.popperOffsets && (e.styles.popper = Object.assign({}, e.styles.popper, ue(Object.assign({}, c, {
                offsets: e.modifiersData.popperOffsets,
                position: e.options.strategy,
                adaptive: r,
                roundOffsets: l
            })))), null != e.modifiersData.arrow && (e.styles.arrow = Object.assign({}, e.styles.arrow, ue(Object.assign({}, c, {
                offsets: e.modifiersData.arrow,
                position: "absolute",
                adaptive: !1,
                roundOffsets: l
            })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
                "data-popper-placement": e.placement
            });
        },
        data: {}
    };
    var pe = {
        passive: !0
    };
    var me = {
        name: "eventListeners",
        enabled: !0,
        phase: "write",
        fn: function fn() {},
        effect: function effect(t) {
            var e = t.state, i = t.instance, n = t.options, s = n.scroll, o = void 0 === s || s, r = n.resize, a = void 0 === r || r, l = $t(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
            return o && c.forEach(function(t) {
                t.addEventListener("scroll", i.update, pe);
            }), a && l.addEventListener("resize", i.update, pe), function() {
                o && c.forEach(function(t) {
                    t.removeEventListener("scroll", i.update, pe);
                }), a && l.removeEventListener("resize", i.update, pe);
            };
        },
        data: {}
    };
    var ge = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
    };
    function _e(t) {
        return t.replace(/left|right|bottom|top/g, function(t) {
            return ge[t];
        });
    }
    var be = {
        start: "end",
        end: "start"
    };
    function ve(t) {
        return t.replace(/start|end/g, function(t) {
            return be[t];
        });
    }
    function ye(t) {
        var e = $t(t);
        return {
            scrollLeft: e.pageXOffset,
            scrollTop: e.pageYOffset
        };
    }
    function we(t) {
        return Ut(ee(t)).left + ye(t).scrollLeft;
    }
    function Ae(t) {
        var e = Zt(t), i = e.overflow, n = e.overflowX, s = e.overflowY;
        return /auto|scroll|overlay|hidden/.test(i + s + n);
    }
    function Ee(t) {
        return [
            "html",
            "body",
            "#document"
        ].indexOf(Ht(t)) >= 0 ? t.ownerDocument.body : Bt(t) && Ae(t) ? t : Ee(ie(t));
    }
    function Te(t, e) {
        var i;
        void 0 === e && (e = []);
        var n = Ee(t), s = n === (null == (i = t.ownerDocument) ? void 0 : i.body), o = $t(n), r = s ? [
            o
        ].concat(o.visualViewport || [], Ae(n) ? n : []) : n, a = e.concat(r);
        return s ? a : a.concat(Te(ie(r)));
    }
    function Ce(t) {
        return Object.assign({}, t, {
            left: t.x,
            top: t.y,
            right: t.x + t.width,
            bottom: t.y + t.height
        });
    }
    function Oe(t, e, i) {
        return e === Et ? Ce(function(t, e) {
            var _$i = $t(t), n = ee(t), s = _$i.visualViewport, o = n.clientWidth, r = n.clientHeight, a = 0, l = 0;
            if (s) {
                o = s.width, r = s.height;
                var c = Yt();
                (c || !c && "fixed" === e) && (a = s.offsetLeft, l = s.offsetTop);
            }
            return {
                width: o,
                height: r,
                x: a + we(t),
                y: l
            };
        }(t, i)) : Wt(e) ? function(t, e) {
            var _$i = Ut(t, !1, "fixed" === e);
            return _$i.top = _$i.top + t.clientTop, _$i.left = _$i.left + t.clientLeft, _$i.bottom = _$i.top + t.clientHeight, _$i.right = _$i.left + t.clientWidth, _$i.width = t.clientWidth, _$i.height = t.clientHeight, _$i.x = _$i.left, _$i.y = _$i.top, _$i;
        }(e, i) : Ce(function(t) {
            var _$e, _$i = ee(t), n = ye(t), s = null == (_$e = t.ownerDocument) ? void 0 : _$e.body, o = Vt(_$i.scrollWidth, _$i.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), r = Vt(_$i.scrollHeight, _$i.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), a = -n.scrollLeft + we(t), l = -n.scrollTop;
            return "rtl" === Zt(s || _$i).direction && (a += Vt(_$i.clientWidth, s ? s.clientWidth : 0) - o), {
                width: o,
                height: r,
                x: a,
                y: l
            };
        }(ee(t)));
    }
    function xe(t) {
        var e, i = t.reference, n = t.element, s = t.placement, o = s ? qt(s) : null, r = s ? he(s) : null, a = i.x + i.width / 2 - n.width / 2, l = i.y + i.height / 2 - n.height / 2;
        switch(o){
            case pt:
                e = {
                    x: a,
                    y: i.y - n.height
                };
                break;
            case mt:
                e = {
                    x: a,
                    y: i.y + i.height
                };
                break;
            case gt:
                e = {
                    x: i.x + i.width,
                    y: l
                };
                break;
            case _t:
                e = {
                    x: i.x - n.width,
                    y: l
                };
                break;
            default:
                e = {
                    x: i.x,
                    y: i.y
                };
        }
        var c = o ? oe(o) : null;
        if (null != c) {
            var h = "y" === c ? "height" : "width";
            switch(r){
                case yt:
                    e[c] = e[c] - (i[h] / 2 - n[h] / 2);
                    break;
                case wt:
                    e[c] = e[c] + (i[h] / 2 - n[h] / 2);
            }
        }
        return e;
    }
    function ke(t, e) {
        void 0 === e && (e = {});
        var i = e, n = i.placement, s = void 0 === n ? t.placement : n, o = i.strategy, r = void 0 === o ? t.strategy : o, a = i.boundary, l = void 0 === a ? At : a, c = i.rootBoundary, h = void 0 === c ? Et : c, d = i.elementContext, u = void 0 === d ? Tt : d, f = i.altBoundary, p = void 0 !== f && f, m = i.padding, g = void 0 === m ? 0 : m, _ = ae("number" != typeof g ? g : le(g, vt)), b = u === Tt ? Ct : Tt, v = t.rects.popper, y = t.elements[p ? b : u], w = function(t, e, i, n) {
            var s = "clippingParents" === e ? function(t) {
                var _$e = Te(ie(t)), _$i = [
                    "absolute",
                    "fixed"
                ].indexOf(Zt(t).position) >= 0 && Bt(t) ? se(t) : t;
                return Wt(_$i) ? _$e.filter(function(t) {
                    return Wt(t) && Jt(t, _$i) && "body" !== Ht(t);
                }) : [];
            }(t) : [].concat(e), o = [].concat(s, [
                i
            ]), r = o[0], a = o.reduce(function(e, i) {
                var s = Oe(t, i, n);
                return e.top = Vt(s.top, e.top), e.right = Kt(s.right, e.right), e.bottom = Kt(s.bottom, e.bottom), e.left = Vt(s.left, e.left), e;
            }, Oe(t, r, n));
            return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
        }(Wt(y) ? y : y.contextElement || ee(t.elements.popper), l, h, r), A = Ut(t.elements.reference), E = xe({
            reference: A,
            element: v,
            strategy: "absolute",
            placement: s
        }), T = Ce(Object.assign({}, v, E)), C = u === Tt ? T : A, O = {
            top: w.top - C.top + _.top,
            bottom: C.bottom - w.bottom + _.bottom,
            left: w.left - C.left + _.left,
            right: C.right - w.right + _.right
        }, x = t.modifiersData.offset;
        if (u === Tt && x) {
            var k = x[s];
            Object.keys(O).forEach(function(t) {
                var _$e = [
                    gt,
                    mt
                ].indexOf(t) >= 0 ? 1 : -1, i = [
                    pt,
                    mt
                ].indexOf(t) >= 0 ? "y" : "x";
                O[t] += k[i] * _$e;
            });
        }
        return O;
    }
    function Le(t, e) {
        void 0 === e && (e = {});
        var i = e, n = i.placement, s = i.boundary, o = i.rootBoundary, r = i.padding, a = i.flipVariations, l = i.allowedAutoPlacements, c = void 0 === l ? xt : l, h = he(n), d = h ? a ? Ot : Ot.filter(function(t) {
            return he(t) === h;
        }) : vt, u = d.filter(function(t) {
            return c.indexOf(t) >= 0;
        });
        0 === u.length && (u = d);
        var f = u.reduce(function(e, i) {
            return e[i] = ke(t, {
                placement: i,
                boundary: s,
                rootBoundary: o,
                padding: r
            })[qt(i)], e;
        }, {});
        return Object.keys(f).sort(function(t, e) {
            return f[t] - f[e];
        });
    }
    var Se = {
        name: "flip",
        enabled: !0,
        phase: "main",
        fn: function fn(t) {
            var e = t.state, i = t.options, n = t.name;
            if (!e.modifiersData[n]._skip) {
                for(var s = i.mainAxis, o = void 0 === s || s, r = i.altAxis, a = void 0 === r || r, l = i.fallbackPlacements, c = i.padding, h = i.boundary, d = i.rootBoundary, u = i.altBoundary, f = i.flipVariations, p = void 0 === f || f, m = i.allowedAutoPlacements, g = e.options.placement, _ = qt(g), b = l || (_ !== g && p ? function(t) {
                    if (qt(t) === bt) return [];
                    var e = _e(t);
                    return [
                        ve(t),
                        e,
                        ve(e)
                    ];
                }(g) : [
                    _e(g)
                ]), v = [
                    g
                ].concat(b).reduce(function(t, i) {
                    return t.concat(qt(i) === bt ? Le(e, {
                        placement: i,
                        boundary: h,
                        rootBoundary: d,
                        padding: c,
                        flipVariations: p,
                        allowedAutoPlacements: m
                    }) : i);
                }, []), y = e.rects.reference, w = e.rects.popper, A = new Map, E = !0, T = v[0], C = 0; C < v.length; C++){
                    var O = v[C], x = qt(O), k = he(O) === yt, L = [
                        pt,
                        mt
                    ].indexOf(x) >= 0, S = L ? "width" : "height", D = ke(e, {
                        placement: O,
                        boundary: h,
                        rootBoundary: d,
                        altBoundary: u,
                        padding: c
                    }), I = L ? k ? gt : _t : k ? mt : pt;
                    y[S] > w[S] && (I = _e(I));
                    var N = _e(I), P = [];
                    if (o && P.push(D[x] <= 0), a && P.push(D[I] <= 0, D[N] <= 0), P.every(function(t) {
                        return t;
                    })) {
                        T = O, E = !1;
                        break;
                    }
                    A.set(O, P);
                }
                if (E) for(var M = function M(t) {
                    var e = v.find(function(e) {
                        var i = A.get(e);
                        if (i) return i.slice(0, t).every(function(t) {
                            return t;
                        });
                    });
                    if (e) return T = e, "break";
                }, j = p ? 3 : 1; j > 0 && "break" !== M(j); j--);
                e.placement !== T && (e.modifiersData[n]._skip = !0, e.placement = T, e.reset = !0);
            }
        },
        requiresIfExists: [
            "offset"
        ],
        data: {
            _skip: !1
        }
    };
    function De(t, e, i) {
        return void 0 === i && (i = {
            x: 0,
            y: 0
        }), {
            top: t.top - e.height - i.y,
            right: t.right - e.width + i.x,
            bottom: t.bottom - e.height + i.y,
            left: t.left - e.width - i.x
        };
    }
    function Ie(t) {
        return [
            pt,
            gt,
            mt,
            _t
        ].some(function(e) {
            return t[e] >= 0;
        });
    }
    var Ne = {
        name: "hide",
        enabled: !0,
        phase: "main",
        requiresIfExists: [
            "preventOverflow"
        ],
        fn: function fn(t) {
            var e = t.state, i = t.name, n = e.rects.reference, s = e.rects.popper, o = e.modifiersData.preventOverflow, r = ke(e, {
                elementContext: "reference"
            }), a = ke(e, {
                altBoundary: !0
            }), l = De(r, n), c = De(a, s, o), h = Ie(l), d = Ie(c);
            e.modifiersData[i] = {
                referenceClippingOffsets: l,
                popperEscapeOffsets: c,
                isReferenceHidden: h,
                hasPopperEscaped: d
            }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
                "data-popper-reference-hidden": h,
                "data-popper-escaped": d
            });
        }
    }, Pe = {
        name: "offset",
        enabled: !0,
        phase: "main",
        requires: [
            "popperOffsets"
        ],
        fn: function fn(t) {
            var e = t.state, i = t.options, n = t.name, s = i.offset, o = void 0 === s ? [
                0,
                0
            ] : s, r = xt.reduce(function(t, i) {
                return t[i] = function(t, e, i) {
                    var n = qt(t), s = [
                        _t,
                        pt
                    ].indexOf(n) >= 0 ? -1 : 1, o = "function" == typeof i ? i(Object.assign({}, e, {
                        placement: t
                    })) : i, r = o[0], a = o[1];
                    return r = r || 0, a = (a || 0) * s, [
                        _t,
                        gt
                    ].indexOf(n) >= 0 ? {
                        x: a,
                        y: r
                    } : {
                        x: r,
                        y: a
                    };
                }(i, e.rects, o), t;
            }, {}), a = r[e.placement], l = a.x, c = a.y;
            null != e.modifiersData.popperOffsets && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[n] = r;
        }
    }, Me = {
        name: "popperOffsets",
        enabled: !0,
        phase: "read",
        fn: function fn(t) {
            var e = t.state, i = t.name;
            e.modifiersData[i] = xe({
                reference: e.rects.reference,
                element: e.rects.popper,
                strategy: "absolute",
                placement: e.placement
            });
        },
        data: {}
    }, je = {
        name: "preventOverflow",
        enabled: !0,
        phase: "main",
        fn: function fn(t) {
            var e = t.state, i = t.options, n = t.name, s = i.mainAxis, o = void 0 === s || s, r = i.altAxis, a = void 0 !== r && r, l = i.boundary, c = i.rootBoundary, h = i.altBoundary, d = i.padding, u = i.tether, f = void 0 === u || u, p = i.tetherOffset, m = void 0 === p ? 0 : p, g = ke(e, {
                boundary: l,
                rootBoundary: c,
                padding: d,
                altBoundary: h
            }), _ = qt(e.placement), b = he(e.placement), v = !b, y = oe(_), w = "x" === y ? "y" : "x", A = e.modifiersData.popperOffsets, E = e.rects.reference, T = e.rects.popper, C = "function" == typeof m ? m(Object.assign({}, e.rects, {
                placement: e.placement
            })) : m, O = "number" == typeof C ? {
                mainAxis: C,
                altAxis: C
            } : Object.assign({
                mainAxis: 0,
                altAxis: 0
            }, C), x = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, k = {
                x: 0,
                y: 0
            };
            if (A) {
                if (o) {
                    var L, S = "y" === y ? pt : _t, D = "y" === y ? mt : gt, I = "y" === y ? "height" : "width", N = A[y], P = N + g[S], M = N - g[D], j = f ? -T[I] / 2 : 0, F = b === yt ? E[I] : T[I], H = b === yt ? -T[I] : -E[I], $ = e.elements.arrow, W = f && $ ? Gt($) : {
                        width: 0,
                        height: 0
                    }, B = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }, z = B[S], R = B[D], q = re(0, E[I], W[I]), V = v ? E[I] / 2 - j - q - z - O.mainAxis : F - q - z - O.mainAxis, K = v ? -E[I] / 2 + j + q + R + O.mainAxis : H + q + R + O.mainAxis, Q = e.elements.arrow && se(e.elements.arrow), X = Q ? "y" === y ? Q.clientTop || 0 : Q.clientLeft || 0 : 0, Y = null != (L = null == x ? void 0 : x[y]) ? L : 0, U = N + K - Y, G = re(f ? Kt(P, N + V - Y - X) : P, N, f ? Vt(M, U) : M);
                    A[y] = G, k[y] = G - N;
                }
                if (a) {
                    var J, Z = "x" === y ? pt : _t, tt = "x" === y ? mt : gt, et = A[w], it = "y" === w ? "height" : "width", nt = et + g[Z], st = et - g[tt], ot = -1 !== [
                        pt,
                        _t
                    ].indexOf(_), rt = null != (J = null == x ? void 0 : x[w]) ? J : 0, at = ot ? nt : et - E[it] - T[it] - rt + O.altAxis, lt = ot ? et + E[it] + T[it] - rt - O.altAxis : st, ct = f && ot ? function(t, e, i) {
                        var n = re(t, e, i);
                        return n > i ? i : n;
                    }(at, et, lt) : re(f ? at : nt, et, f ? lt : st);
                    A[w] = ct, k[w] = ct - et;
                }
                e.modifiersData[n] = k;
            }
        },
        requiresIfExists: [
            "offset"
        ]
    };
    function Fe(t, e, i) {
        void 0 === i && (i = !1);
        var n, s, o = Bt(e), r = Bt(e) && function(t) {
            var _$e = t.getBoundingClientRect(), _$i = Qt(_$e.width) / t.offsetWidth || 1, n = Qt(_$e.height) / t.offsetHeight || 1;
            return 1 !== _$i || 1 !== n;
        }(e), a = ee(e), l = Ut(t, r, i), c = {
            scrollLeft: 0,
            scrollTop: 0
        }, h = {
            x: 0,
            y: 0
        };
        return (o || !o && !i) && (("body" !== Ht(e) || Ae(a)) && (c = (n = e) !== $t(n) && Bt(n) ? {
            scrollLeft: (s = n).scrollLeft,
            scrollTop: s.scrollTop
        } : ye(n)), Bt(e) ? ((h = Ut(e, !0)).x += e.clientLeft, h.y += e.clientTop) : a && (h.x = we(a))), {
            x: l.left + c.scrollLeft - h.x,
            y: l.top + c.scrollTop - h.y,
            width: l.width,
            height: l.height
        };
    }
    function He(t) {
        var e = new Map, i = new Set, n = [];
        function s(t) {
            i.add(t.name), [].concat(t.requires || [], t.requiresIfExists || []).forEach(function(t) {
                if (!i.has(t)) {
                    var n = e.get(t);
                    n && s(n);
                }
            }), n.push(t);
        }
        return t.forEach(function(t) {
            e.set(t.name, t);
        }), t.forEach(function(t) {
            i.has(t.name) || s(t);
        }), n;
    }
    var $e = {
        placement: "bottom",
        modifiers: [],
        strategy: "absolute"
    };
    function We() {
        for(var t = arguments.length, e = new Array(t), i = 0; i < t; i++)e[i] = arguments[i];
        return !e.some(function(t) {
            return !(t && "function" == typeof t.getBoundingClientRect);
        });
    }
    function Be(t) {
        void 0 === t && (t = {});
        var e = t, i = e.defaultModifiers, n = void 0 === i ? [] : i, s = e.defaultOptions, o = void 0 === s ? $e : s;
        return function(t, e, i) {
            void 0 === i && (i = o);
            var s, r, a = {
                placement: "bottom",
                orderedModifiers: [],
                options: Object.assign({}, $e, o),
                modifiersData: {},
                elements: {
                    reference: t,
                    popper: e
                },
                attributes: {},
                styles: {}
            }, l = [], c = !1, h = {
                state: a,
                setOptions: function setOptions(i) {
                    var s = "function" == typeof i ? i(a.options) : i;
                    d(), a.options = Object.assign({}, o, a.options, s), a.scrollParents = {
                        reference: Wt(t) ? Te(t) : t.contextElement ? Te(t.contextElement) : [],
                        popper: Te(e)
                    };
                    var r, c, u = function(t) {
                        var _$e = He(t);
                        return Ft.reduce(function(t, i) {
                            return t.concat(_$e.filter(function(t) {
                                return t.phase === i;
                            }));
                        }, []);
                    }((r = [].concat(n, a.options.modifiers), c = r.reduce(function(t, e) {
                        var _$i = t[e.name];
                        return t[e.name] = _$i ? Object.assign({}, _$i, e, {
                            options: Object.assign({}, _$i.options, e.options),
                            data: Object.assign({}, _$i.data, e.data)
                        }) : e, t;
                    }, {}), Object.keys(c).map(function(t) {
                        return c[t];
                    })));
                    return a.orderedModifiers = u.filter(function(t) {
                        return t.enabled;
                    }), a.orderedModifiers.forEach(function(t) {
                        var _$e = t.name, _$i = t.options, n = void 0 === _$i ? {} : _$i, s = t.effect;
                        if ("function" == typeof s) {
                            var o = s({
                                state: a,
                                name: _$e,
                                instance: h,
                                options: n
                            });
                            l.push(o || function() {});
                        }
                    }), h.update();
                },
                forceUpdate: function forceUpdate() {
                    if (!c) {
                        var _$t = a.elements, _$e = _$t.reference, _$i = _$t.popper;
                        if (We(_$e, _$i)) {
                            a.rects = {
                                reference: Fe(_$e, se(_$i), "fixed" === a.options.strategy),
                                popper: Gt(_$i)
                            }, a.reset = !1, a.placement = a.options.placement, a.orderedModifiers.forEach(function(t) {
                                return a.modifiersData[t.name] = Object.assign({}, t.data);
                            });
                            for(var n = 0; n < a.orderedModifiers.length; n++)if (!0 !== a.reset) {
                                var s = a.orderedModifiers[n], o = s.fn, r = s.options, l = void 0 === r ? {} : r, d = s.name;
                                "function" == typeof o && (a = o({
                                    state: a,
                                    options: l,
                                    name: d,
                                    instance: h
                                }) || a);
                            } else a.reset = !1, n = -1;
                        }
                    }
                },
                update: (s = function s() {
                    return new Promise(function(t) {
                        h.forceUpdate(), t(a);
                    });
                }, function() {
                    return r || (r = new Promise(function(t) {
                        Promise.resolve().then(function() {
                            r = void 0, t(s());
                        });
                    })), r;
                }),
                destroy: function destroy() {
                    d(), c = !0;
                }
            };
            if (!We(t, e)) return h;
            function d() {
                l.forEach(function(t) {
                    return t();
                }), l = [];
            }
            return h.setOptions(i).then(function(t) {
                !c && i.onFirstUpdate && i.onFirstUpdate(t);
            }), h;
        };
    }
    var ze = Be(), Re = Be({
        defaultModifiers: [
            me,
            Me,
            fe,
            Rt
        ]
    }), qe = Be({
        defaultModifiers: [
            me,
            Me,
            fe,
            Rt,
            Pe,
            Se,
            je,
            ce,
            Ne
        ]
    });
    var Ve = Object.freeze(Object.defineProperty({
        __proto__: null,
        afterMain: Nt,
        afterRead: St,
        afterWrite: jt,
        applyStyles: Rt,
        arrow: ce,
        auto: bt,
        basePlacements: vt,
        beforeMain: Dt,
        beforeRead: kt,
        beforeWrite: Pt,
        bottom: mt,
        clippingParents: At,
        computeStyles: fe,
        createPopper: qe,
        createPopperBase: ze,
        createPopperLite: Re,
        detectOverflow: ke,
        end: wt,
        eventListeners: me,
        flip: Se,
        hide: Ne,
        left: _t,
        main: It,
        modifierPhases: Ft,
        offset: Pe,
        placements: xt,
        popper: Tt,
        popperGenerator: Be,
        popperOffsets: Me,
        preventOverflow: je,
        read: Lt,
        reference: Ct,
        right: gt,
        start: yt,
        top: pt,
        variationPlacements: Ot,
        viewport: Et,
        write: Mt
    }, Symbol.toStringTag, {
        value: "Module"
    })), Ke = "dropdown", Qe = "ArrowUp", Xe = "ArrowDown", Ye = "click.bs.dropdown.data-api", Ue = "keydown.bs.dropdown.data-api", Ge = "show", Je = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', Ze = "".concat(Je, ".show"), ti = ".dropdown-menu", ei = p() ? "top-end" : "top-start", ii = p() ? "top-start" : "top-end", ni = p() ? "bottom-end" : "bottom-start", si = p() ? "bottom-start" : "bottom-end", oi = p() ? "left-start" : "right-start", ri = p() ? "right-start" : "left-start", ai = {
        autoClose: !0,
        boundary: "clippingParents",
        display: "dynamic",
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: "toggle"
    }, li = {
        autoClose: "(boolean|string)",
        boundary: "(string|element)",
        display: "string",
        offset: "(array|string|function)",
        popperConfig: "(null|object|function)",
        reference: "(string|element|object)"
    };
    var ci = /*#__PURE__*/ function(W) {
        _inherits(ci, W);
        var _super = _create_super(ci);
        function ci(t, e) {
            _class_call_check(this, ci);
            var _this;
            _this = _super.call(this, t, e), _this._popper = null, _this._parent = _this._element.parentNode, _this._menu = z.next(_this._element, ti)[0] || z.prev(_this._element, ti)[0] || z.findOne(ti, _this._parent), _this._inNavbar = _this._detectNavbar();
            return _possible_constructor_return(_this);
        }
        _create_class(ci, [
            {
                key: "toggle",
                value: function toggle() {
                    return this._isShown() ? this.hide() : this.show();
                }
            },
            {
                key: "show",
                value: function show() {
                    if (l(this._element) || this._isShown()) return;
                    var t = {
                        relatedTarget: this._element
                    };
                    if (!P.trigger(this._element, "show.bs.dropdown", t).defaultPrevented) {
                        var _instance;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest(".navbar-nav")) try {
                            for(var _iterator = (_instance = []).concat.apply(_instance, _to_consumable_array(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var t1 = _step.value;
                                P.on(t1, "mouseover", h);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._element.focus(), this._element.setAttribute("aria-expanded", !0), this._menu.classList.add(Ge), this._element.classList.add(Ge), P.trigger(this._element, "shown.bs.dropdown", t);
                    }
                }
            },
            {
                key: "hide",
                value: function hide() {
                    if (l(this._element) || !this._isShown()) return;
                    var t = {
                        relatedTarget: this._element
                    };
                    this._completeHide(t);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this._popper && this._popper.destroy(), _get(_get_prototype_of(ci.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "update",
                value: function update() {
                    this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
                }
            },
            {
                key: "_completeHide",
                value: function _completeHide(t) {
                    if (!P.trigger(this._element, "hide.bs.dropdown", t).defaultPrevented) {
                        var _instance;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if ("ontouchstart" in document.documentElement) try {
                            for(var _iterator = (_instance = []).concat.apply(_instance, _to_consumable_array(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                P.off(_$t, "mouseover", h);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._popper && this._popper.destroy(), this._menu.classList.remove(Ge), this._element.classList.remove(Ge), this._element.setAttribute("aria-expanded", "false"), H.removeDataAttribute(this._menu, "popper"), P.trigger(this._element, "hidden.bs.dropdown", t);
                    }
                }
            },
            {
                key: "_getConfig",
                value: function _getConfig(t) {
                    if ("object" == typeof (t = _get(_get_prototype_of(ci.prototype), "_getConfig", this).call(this, t)).reference && !o(t.reference) && "function" != typeof t.reference.getBoundingClientRect) throw new TypeError("".concat(Ke.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                    return t;
                }
            },
            {
                key: "_createPopper",
                value: function _createPopper() {
                    if (void 0 === Ve) throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                    var t = this._element;
                    "parent" === this._config.reference ? t = this._parent : o(this._config.reference) ? t = r(this._config.reference) : "object" == typeof this._config.reference && (t = this._config.reference);
                    var e = this._getPopperConfig();
                    this._popper = qe(t, this._menu, e);
                }
            },
            {
                key: "_isShown",
                value: function _isShown() {
                    return this._menu.classList.contains(Ge);
                }
            },
            {
                key: "_getPlacement",
                value: function _getPlacement() {
                    var t = this._parent;
                    if (t.classList.contains("dropend")) return oi;
                    if (t.classList.contains("dropstart")) return ri;
                    if (t.classList.contains("dropup-center")) return "top";
                    if (t.classList.contains("dropdown-center")) return "bottom";
                    var e = "end" === getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();
                    return t.classList.contains("dropup") ? e ? ii : ei : e ? si : ni;
                }
            },
            {
                key: "_detectNavbar",
                value: function _detectNavbar() {
                    return null !== this._element.closest(".navbar");
                }
            },
            {
                key: "_getOffset",
                value: function _getOffset() {
                    var _this = this;
                    var _this__config = this._config, t = _this__config.offset;
                    return "string" == typeof t ? t.split(",").map(function(t) {
                        return Number.parseInt(t, 10);
                    }) : "function" == typeof t ? function(e) {
                        return t(e, _this._element);
                    } : t;
                }
            },
            {
                key: "_getPopperConfig",
                value: function _getPopperConfig() {
                    var t = {
                        placement: this._getPlacement(),
                        modifiers: [
                            {
                                name: "preventOverflow",
                                options: {
                                    boundary: this._config.boundary
                                }
                            },
                            {
                                name: "offset",
                                options: {
                                    offset: this._getOffset()
                                }
                            }
                        ]
                    };
                    return (this._inNavbar || "static" === this._config.display) && (H.setDataAttribute(this._menu, "popper", "static"), t.modifiers = [
                        {
                            name: "applyStyles",
                            enabled: !1
                        }
                    ]), _object_spread({}, t, g(this._config.popperConfig, [
                        t
                    ]));
                }
            },
            {
                key: "_selectMenuItem",
                value: function _selectMenuItem(param) {
                    var t = param.key, e = param.target;
                    var i = z.find(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", this._menu).filter(function(t) {
                        return a(t);
                    });
                    i.length && b(i, e, t === Xe, !i.includes(e)).focus();
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return ai;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return li;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return Ke;
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = ci.getOrCreateInstance(this, t);
                        if ("string" == typeof t) {
                            if (void 0 === e[t]) throw new TypeError('No method named "'.concat(t, '"'));
                            e[t]();
                        }
                    });
                }
            },
            {
                key: "clearMenus",
                value: function clearMenus(t) {
                    if (2 === t.button || "keyup" === t.type && "Tab" !== t.key) return;
                    var e = z.find(Ze);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            var e1 = ci.getInstance(i);
                            if (!e1 || !1 === e1._config.autoClose) continue;
                            var n = t.composedPath(), s = n.includes(e1._menu);
                            if (n.includes(e1._element) || "inside" === e1._config.autoClose && !s || "outside" === e1._config.autoClose && s) continue;
                            if (e1._menu.contains(t.target) && ("keyup" === t.type && "Tab" === t.key || /input|select|option|textarea|form/i.test(t.target.tagName))) continue;
                            var o = {
                                relatedTarget: e1._element
                            };
                            "click" === t.type && (o.clickEvent = t), e1._completeHide(o);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "dataApiKeydownHandler",
                value: function dataApiKeydownHandler(t) {
                    var e = /input|textarea/i.test(t.target.tagName), i = "Escape" === t.key, n = [
                        Qe,
                        Xe
                    ].includes(t.key);
                    if (!n && !i) return;
                    if (e && !i) return;
                    t.preventDefault();
                    var s = this.matches(Je) ? this : z.prev(this, Je)[0] || z.next(this, Je)[0] || z.findOne(Je, t.delegateTarget.parentNode), o = ci.getOrCreateInstance(s);
                    if (n) return t.stopPropagation(), o.show(), void o._selectMenuItem(t);
                    o._isShown() && (t.stopPropagation(), o.hide(), s.focus());
                }
            }
        ]);
        return ci;
    }(W);
    P.on(document, Ue, Je, ci.dataApiKeydownHandler), P.on(document, Ue, ti, ci.dataApiKeydownHandler), P.on(document, Ye, ci.clearMenus), P.on(document, "keyup.bs.dropdown.data-api", ci.clearMenus), P.on(document, Ye, Je, function(t) {
        t.preventDefault(), ci.getOrCreateInstance(this).toggle();
    }), m(ci);
    var hi = "show", di = "mousedown.bs.backdrop", ui = {
        className: "modal-backdrop",
        clickCallback: null,
        isAnimated: !1,
        isVisible: !0,
        rootElement: "body"
    }, fi = {
        className: "string",
        clickCallback: "(function|null)",
        isAnimated: "boolean",
        isVisible: "boolean",
        rootElement: "(element|string)"
    };
    var pi = /*#__PURE__*/ function($) {
        _inherits(pi, $);
        var _super = _create_super(pi);
        function pi(t) {
            _class_call_check(this, pi);
            var _this;
            _this = _super.call(this), _this._config = _this._getConfig(t), _this._isAppended = !1, _this._element = null;
            return _possible_constructor_return(_this);
        }
        _create_class(pi, [
            {
                key: "show",
                value: function show(t) {
                    if (!this._config.isVisible) return void g(t);
                    this._append();
                    var e = this._getElement();
                    this._config.isAnimated && d(e), e.classList.add(hi), this._emulateAnimation(function() {
                        g(t);
                    });
                }
            },
            {
                key: "hide",
                value: function hide(t) {
                    var _this = this;
                    this._config.isVisible ? (this._getElement().classList.remove(hi), this._emulateAnimation(function() {
                        _this.dispose(), g(t);
                    })) : g(t);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this._isAppended && (P.off(this._element, di), this._element.remove(), this._isAppended = !1);
                }
            },
            {
                key: "_getElement",
                value: function _getElement() {
                    if (!this._element) {
                        var t = document.createElement("div");
                        t.className = this._config.className, this._config.isAnimated && t.classList.add("fade"), this._element = t;
                    }
                    return this._element;
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(t) {
                    return t.rootElement = r(t.rootElement), t;
                }
            },
            {
                key: "_append",
                value: function _append() {
                    var _this = this;
                    if (this._isAppended) return;
                    var t = this._getElement();
                    this._config.rootElement.append(t), P.on(t, di, function() {
                        g(_this._config.clickCallback);
                    }), this._isAppended = !0;
                }
            },
            {
                key: "_emulateAnimation",
                value: function _emulateAnimation(t) {
                    _(t, this._getElement(), this._config.isAnimated);
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return ui;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return fi;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "backdrop";
                }
            }
        ]);
        return pi;
    }($);
    var mi = ".bs.focustrap", gi = "backward", _i = {
        autofocus: !0,
        trapElement: null
    }, bi = {
        autofocus: "boolean",
        trapElement: "element"
    };
    var vi = /*#__PURE__*/ function($) {
        _inherits(vi, $);
        var _super = _create_super(vi);
        function vi(t) {
            _class_call_check(this, vi);
            var _this;
            _this = _super.call(this), _this._config = _this._getConfig(t), _this._isActive = !1, _this._lastTabNavDirection = null;
            return _possible_constructor_return(_this);
        }
        _create_class(vi, [
            {
                key: "activate",
                value: function activate() {
                    var _this = this;
                    this._isActive || (this._config.autofocus && this._config.trapElement.focus(), P.off(document, mi), P.on(document, "focusin.bs.focustrap", function(t) {
                        return _this._handleFocusin(t);
                    }), P.on(document, "keydown.tab.bs.focustrap", function(t) {
                        return _this._handleKeydown(t);
                    }), this._isActive = !0);
                }
            },
            {
                key: "deactivate",
                value: function deactivate() {
                    this._isActive && (this._isActive = !1, P.off(document, mi));
                }
            },
            {
                key: "_handleFocusin",
                value: function _handleFocusin(t) {
                    var _this__config = this._config, e = _this__config.trapElement;
                    if (t.target === document || t.target === e || e.contains(t.target)) return;
                    var i = z.focusableChildren(e);
                    0 === i.length ? e.focus() : this._lastTabNavDirection === gi ? i[i.length - 1].focus() : i[0].focus();
                }
            },
            {
                key: "_handleKeydown",
                value: function _handleKeydown(t) {
                    "Tab" === t.key && (this._lastTabNavDirection = t.shiftKey ? gi : "forward");
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return _i;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return bi;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "focustrap";
                }
            }
        ]);
        return vi;
    }($);
    var yi = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", wi = ".sticky-top", Ai = "padding-right", Ei = "margin-right";
    var Ti = /*#__PURE__*/ function() {
        function Ti() {
            _class_call_check(this, Ti);
            this._element = document.body;
        }
        _create_class(Ti, [
            {
                key: "getWidth",
                value: function getWidth() {
                    var t = document.documentElement.clientWidth;
                    return Math.abs(window.innerWidth - t);
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var t = this.getWidth();
                    this._disableOverFlow(), this._setElementAttributes(this._element, Ai, function(e) {
                        return e + t;
                    }), this._setElementAttributes(yi, Ai, function(e) {
                        return e + t;
                    }), this._setElementAttributes(wi, Ei, function(e) {
                        return e - t;
                    });
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, Ai), this._resetElementAttributes(yi, Ai), this._resetElementAttributes(wi, Ei);
                }
            },
            {
                key: "isOverflowing",
                value: function isOverflowing() {
                    return this.getWidth() > 0;
                }
            },
            {
                key: "_disableOverFlow",
                value: function _disableOverFlow() {
                    this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
                }
            },
            {
                key: "_setElementAttributes",
                value: function _setElementAttributes(t, e, i) {
                    var _this = this;
                    var n = this.getWidth();
                    this._applyManipulationCallback(t, function(t) {
                        if (t !== _this._element && window.innerWidth > t.clientWidth + n) return;
                        _this._saveInitialAttribute(t, e);
                        var s = window.getComputedStyle(t).getPropertyValue(e);
                        t.style.setProperty(e, "".concat(i(Number.parseFloat(s)), "px"));
                    });
                }
            },
            {
                key: "_saveInitialAttribute",
                value: function _saveInitialAttribute(t, e) {
                    var i = t.style.getPropertyValue(e);
                    i && H.setDataAttribute(t, e, i);
                }
            },
            {
                key: "_resetElementAttributes",
                value: function _resetElementAttributes(t, e) {
                    this._applyManipulationCallback(t, function(t) {
                        var i = H.getDataAttribute(t, e);
                        null !== i ? (H.removeDataAttribute(t, e), t.style.setProperty(e, i)) : t.style.removeProperty(e);
                    });
                }
            },
            {
                key: "_applyManipulationCallback",
                value: function _applyManipulationCallback(t, e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (o(t)) e(t);
                    else try {
                        for(var _iterator = z.find(t, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            e(i);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ]);
        return Ti;
    }();
    var Ci = ".bs.modal", Oi = "hidden.bs.modal", xi = "show.bs.modal", ki = "modal-open", Li = "show", Si = "modal-static", Di = {
        backdrop: !0,
        focus: !0,
        keyboard: !0
    }, Ii = {
        backdrop: "(boolean|string)",
        focus: "boolean",
        keyboard: "boolean"
    };
    var Ni = /*#__PURE__*/ function(W) {
        _inherits(Ni, W);
        var _super = _create_super(Ni);
        function Ni(t, e) {
            _class_call_check(this, Ni);
            var _this;
            _this = _super.call(this, t, e), _this._dialog = z.findOne(".modal-dialog", _this._element), _this._backdrop = _this._initializeBackDrop(), _this._focustrap = _this._initializeFocusTrap(), _this._isShown = !1, _this._isTransitioning = !1, _this._scrollBar = new Ti, _this._addEventListeners();
            return _possible_constructor_return(_this);
        }
        _create_class(Ni, [
            {
                key: "toggle",
                value: function toggle(t) {
                    return this._isShown ? this.hide() : this.show(t);
                }
            },
            {
                key: "show",
                value: function show(t) {
                    var _this = this;
                    this._isShown || this._isTransitioning || P.trigger(this._element, xi, {
                        relatedTarget: t
                    }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(ki), this._adjustDialog(), this._backdrop.show(function() {
                        return _this._showElement(t);
                    }));
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    this._isShown && !this._isTransitioning && (P.trigger(this._element, "hide.bs.modal").defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(Li), this._queueCallback(function() {
                        return _this._hideModal();
                    }, this._element, this._isAnimated())));
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    P.off(window, Ci), P.off(this._dialog, Ci), this._backdrop.dispose(), this._focustrap.deactivate(), _get(_get_prototype_of(Ni.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "handleUpdate",
                value: function handleUpdate() {
                    this._adjustDialog();
                }
            },
            {
                key: "_initializeBackDrop",
                value: function _initializeBackDrop() {
                    return new pi({
                        isVisible: Boolean(this._config.backdrop),
                        isAnimated: this._isAnimated()
                    });
                }
            },
            {
                key: "_initializeFocusTrap",
                value: function _initializeFocusTrap() {
                    return new vi({
                        trapElement: this._element
                    });
                }
            },
            {
                key: "_showElement",
                value: function _showElement(t) {
                    var _this = this;
                    document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
                    var e = z.findOne(".modal-body", this._dialog);
                    e && (e.scrollTop = 0), d(this._element), this._element.classList.add(Li), this._queueCallback(function() {
                        _this._config.focus && _this._focustrap.activate(), _this._isTransitioning = !1, P.trigger(_this._element, "shown.bs.modal", {
                            relatedTarget: t
                        });
                    }, this._dialog, this._isAnimated());
                }
            },
            {
                key: "_addEventListeners",
                value: function _addEventListeners() {
                    var _this = this;
                    P.on(this._element, "keydown.dismiss.bs.modal", function(t) {
                        "Escape" === t.key && (_this._config.keyboard ? _this.hide() : _this._triggerBackdropTransition());
                    }), P.on(window, "resize.bs.modal", function() {
                        _this._isShown && !_this._isTransitioning && _this._adjustDialog();
                    }), P.on(this._element, "mousedown.dismiss.bs.modal", function(t) {
                        P.one(_this._element, "click.dismiss.bs.modal", function(e) {
                            _this._element === t.target && _this._element === e.target && ("static" !== _this._config.backdrop ? _this._config.backdrop && _this.hide() : _this._triggerBackdropTransition());
                        });
                    });
                }
            },
            {
                key: "_hideModal",
                value: function _hideModal() {
                    var _this = this;
                    this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(function() {
                        document.body.classList.remove(ki), _this._resetAdjustments(), _this._scrollBar.reset(), P.trigger(_this._element, Oi);
                    });
                }
            },
            {
                key: "_isAnimated",
                value: function _isAnimated() {
                    return this._element.classList.contains("fade");
                }
            },
            {
                key: "_triggerBackdropTransition",
                value: function _triggerBackdropTransition() {
                    var _this = this;
                    if (P.trigger(this._element, "hidePrevented.bs.modal").defaultPrevented) return;
                    var t = this._element.scrollHeight > document.documentElement.clientHeight, e = this._element.style.overflowY;
                    "hidden" === e || this._element.classList.contains(Si) || (t || (this._element.style.overflowY = "hidden"), this._element.classList.add(Si), this._queueCallback(function() {
                        _this._element.classList.remove(Si), _this._queueCallback(function() {
                            _this._element.style.overflowY = e;
                        }, _this._dialog);
                    }, this._dialog), this._element.focus());
                }
            },
            {
                key: "_adjustDialog",
                value: function _adjustDialog() {
                    var t = this._element.scrollHeight > document.documentElement.clientHeight, e = this._scrollBar.getWidth(), i = e > 0;
                    if (i && !t) {
                        var t1 = p() ? "paddingLeft" : "paddingRight";
                        this._element.style[t1] = "".concat(e, "px");
                    }
                    if (!i && t) {
                        var t2 = p() ? "paddingRight" : "paddingLeft";
                        this._element.style[t2] = "".concat(e, "px");
                    }
                }
            },
            {
                key: "_resetAdjustments",
                value: function _resetAdjustments() {
                    this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return Di;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return Ii;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "modal";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t, e) {
                    return this.each(function() {
                        var i = Ni.getOrCreateInstance(this, t);
                        if ("string" == typeof t) {
                            if (void 0 === i[t]) throw new TypeError('No method named "'.concat(t, '"'));
                            i[t](e);
                        }
                    });
                }
            }
        ]);
        return Ni;
    }(W);
    P.on(document, "click.bs.modal.data-api", '[data-bs-toggle="modal"]', function(t) {
        var _this = this;
        var e = z.getElementFromSelector(this);
        [
            "A",
            "AREA"
        ].includes(this.tagName) && t.preventDefault(), P.one(e, xi, function(t) {
            t.defaultPrevented || P.one(e, Oi, function() {
                a(_this) && _this.focus();
            });
        });
        var i = z.findOne(".modal.show");
        i && Ni.getInstance(i).hide(), Ni.getOrCreateInstance(e).toggle(this);
    }), R(Ni), m(Ni);
    var Pi = "show", Mi = "showing", ji = "hiding", Fi = ".offcanvas.show", Hi = "hidePrevented.bs.offcanvas", $i = "hidden.bs.offcanvas", Wi = {
        backdrop: !0,
        keyboard: !0,
        scroll: !1
    }, Bi = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        scroll: "boolean"
    };
    var zi = /*#__PURE__*/ function(W) {
        _inherits(zi, W);
        var _super = _create_super(zi);
        function zi(t, e) {
            _class_call_check(this, zi);
            var _this;
            _this = _super.call(this, t, e), _this._isShown = !1, _this._backdrop = _this._initializeBackDrop(), _this._focustrap = _this._initializeFocusTrap(), _this._addEventListeners();
            return _possible_constructor_return(_this);
        }
        _create_class(zi, [
            {
                key: "toggle",
                value: function toggle(t) {
                    return this._isShown ? this.hide() : this.show(t);
                }
            },
            {
                key: "show",
                value: function show(t) {
                    var _this = this;
                    this._isShown || P.trigger(this._element, "show.bs.offcanvas", {
                        relatedTarget: t
                    }).defaultPrevented || (this._isShown = !0, this._backdrop.show(), this._config.scroll || (new Ti).hide(), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.classList.add(Mi), this._queueCallback(function() {
                        _this._config.scroll && !_this._config.backdrop || _this._focustrap.activate(), _this._element.classList.add(Pi), _this._element.classList.remove(Mi), P.trigger(_this._element, "shown.bs.offcanvas", {
                            relatedTarget: t
                        });
                    }, this._element, !0));
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    this._isShown && (P.trigger(this._element, "hide.bs.offcanvas").defaultPrevented || (this._focustrap.deactivate(), this._element.blur(), this._isShown = !1, this._element.classList.add(ji), this._backdrop.hide(), this._queueCallback(function() {
                        _this._element.classList.remove(Pi, ji), _this._element.removeAttribute("aria-modal"), _this._element.removeAttribute("role"), _this._config.scroll || (new Ti).reset(), P.trigger(_this._element, $i);
                    }, this._element, !0)));
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this._backdrop.dispose(), this._focustrap.deactivate(), _get(_get_prototype_of(zi.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "_initializeBackDrop",
                value: function _initializeBackDrop() {
                    var _this = this;
                    var t = Boolean(this._config.backdrop);
                    return new pi({
                        className: "offcanvas-backdrop",
                        isVisible: t,
                        isAnimated: !0,
                        rootElement: this._element.parentNode,
                        clickCallback: t ? function() {
                            "static" !== _this._config.backdrop ? _this.hide() : P.trigger(_this._element, Hi);
                        } : null
                    });
                }
            },
            {
                key: "_initializeFocusTrap",
                value: function _initializeFocusTrap() {
                    return new vi({
                        trapElement: this._element
                    });
                }
            },
            {
                key: "_addEventListeners",
                value: function _addEventListeners() {
                    var _this = this;
                    P.on(this._element, "keydown.dismiss.bs.offcanvas", function(t) {
                        "Escape" === t.key && (_this._config.keyboard ? _this.hide() : P.trigger(_this._element, Hi));
                    });
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return Wi;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return Bi;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "offcanvas";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = zi.getOrCreateInstance(this, t);
                        if ("string" == typeof t) {
                            if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError('No method named "'.concat(t, '"'));
                            e[t](this);
                        }
                    });
                }
            }
        ]);
        return zi;
    }(W);
    P.on(document, "click.bs.offcanvas.data-api", '[data-bs-toggle="offcanvas"]', function(t) {
        var _this = this;
        var e = z.getElementFromSelector(this);
        if ([
            "A",
            "AREA"
        ].includes(this.tagName) && t.preventDefault(), l(this)) return;
        P.one(e, $i, function() {
            a(_this) && _this.focus();
        });
        var i = z.findOne(Fi);
        i && i !== e && zi.getInstance(i).hide(), zi.getOrCreateInstance(e).toggle(this);
    }), P.on(window, "load.bs.offcanvas.data-api", function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = z.find(Fi)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                zi.getOrCreateInstance(t).show();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }), P.on(window, "resize.bs.offcanvas", function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = z.find("[aria-modal][class*=show][class*=offcanvas-]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                "fixed" !== getComputedStyle(t).position && zi.getOrCreateInstance(t).hide();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }), R(zi), m(zi);
    var Ri = {
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            /^aria-[\w-]*$/i
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    }, qi = new Set([
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ]), Vi = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, Ki = function(t, e) {
        var i = t.nodeName.toLowerCase();
        return e.includes(i) ? !qi.has(i) || Boolean(Vi.test(t.nodeValue)) : e.filter(function(t) {
            return t instanceof RegExp;
        }).some(function(t) {
            return t.test(i);
        });
    }, Qi = {
        allowList: Ri,
        content: {},
        extraClass: "",
        html: !1,
        sanitize: !0,
        sanitizeFn: null,
        template: "<div></div>"
    }, Xi = {
        allowList: "object",
        content: "object",
        extraClass: "(string|function)",
        html: "boolean",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        template: "string"
    }, Yi = {
        entry: "(string|element|function|null)",
        selector: "(string|element)"
    };
    var Ui = /*#__PURE__*/ function($) {
        _inherits(Ui, $);
        var _super = _create_super(Ui);
        function Ui(t) {
            _class_call_check(this, Ui);
            var _this;
            _this = _super.call(this), _this._config = _this._getConfig(t);
            return _possible_constructor_return(_this);
        }
        _create_class(Ui, [
            {
                key: "getContent",
                value: function getContent() {
                    var _this = this;
                    return Object.values(this._config.content).map(function(t) {
                        return _this._resolvePossibleFunction(t);
                    }).filter(Boolean);
                }
            },
            {
                key: "hasContent",
                value: function hasContent() {
                    return this.getContent().length > 0;
                }
            },
            {
                key: "changeContent",
                value: function changeContent(t) {
                    return this._checkContent(t), this._config.content = _object_spread({}, this._config.content, t), this;
                }
            },
            {
                key: "toHtml",
                value: function toHtml() {
                    var _e_classList;
                    var t = document.createElement("div");
                    t.innerHTML = this._maybeSanitize(this._config.template);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(this._config.content)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _sliced_to_array(_step.value, 2), e = _step_value[0], i = _step_value[1];
                            this._setContent(t, i, e);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var e1 = t.children[0], i1 = this._resolvePossibleFunction(this._config.extraClass);
                    return i1 && (_e_classList = e1.classList).add.apply(_e_classList, _to_consumable_array(i1.split(" "))), e1;
                }
            },
            {
                key: "_typeCheckConfig",
                value: function _typeCheckConfig(t) {
                    _get(_get_prototype_of(Ui.prototype), "_typeCheckConfig", this).call(this, t), this._checkContent(t.content);
                }
            },
            {
                key: "_checkContent",
                value: function _checkContent(t) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _sliced_to_array(_step.value, 2), e = _step_value[0], i = _step_value[1];
                            _get(_get_prototype_of(Ui.prototype), "_typeCheckConfig", this).call(this, {
                                selector: e,
                                entry: i
                            }, Yi);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_setContent",
                value: function _setContent(t, e, i) {
                    var n = z.findOne(i, t);
                    n && ((e = this._resolvePossibleFunction(e)) ? o(e) ? this._putElementInTemplate(r(e), n) : this._config.html ? n.innerHTML = this._maybeSanitize(e) : n.textContent = e : n.remove());
                }
            },
            {
                key: "_maybeSanitize",
                value: function _maybeSanitize(t) {
                    return this._config.sanitize ? function(t, e, i) {
                        var _instance;
                        if (!t.length) return t;
                        if (i && "function" == typeof i) return i(t);
                        var n = (new window.DOMParser).parseFromString(t, "text/html"), s = (_instance = []).concat.apply(_instance, _to_consumable_array(n.body.querySelectorAll("*")));
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                var _instance1;
                                var _$i = _$t.nodeName.toLowerCase();
                                if (!Object.keys(e).includes(_$i)) {
                                    _$t.remove();
                                    continue;
                                }
                                var n1 = (_instance1 = []).concat.apply(_instance1, _to_consumable_array(_$t.attributes)), s1 = [].concat(e["*"] || [], e[_$i] || []);
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = n1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var _$e = _step1.value;
                                        Ki(_$e, s1) || _$t.removeAttribute(_$e.nodeName);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return n.body.innerHTML;
                    }(t, this._config.allowList, this._config.sanitizeFn) : t;
                }
            },
            {
                key: "_resolvePossibleFunction",
                value: function _resolvePossibleFunction(t) {
                    return g(t, [
                        this
                    ]);
                }
            },
            {
                key: "_putElementInTemplate",
                value: function _putElementInTemplate(t, e) {
                    if (this._config.html) return e.innerHTML = "", void e.append(t);
                    e.textContent = t.textContent;
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return Qi;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return Xi;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "TemplateFactory";
                }
            }
        ]);
        return Ui;
    }($);
    var Gi = new Set([
        "sanitize",
        "allowList",
        "sanitizeFn"
    ]), Ji = "fade", Zi = "show", tn = ".modal", en = "hide.bs.modal", nn = "hover", sn = "focus", on = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: p() ? "left" : "right",
        BOTTOM: "bottom",
        LEFT: p() ? "right" : "left"
    }, rn = {
        allowList: Ri,
        animation: !0,
        boundary: "clippingParents",
        container: !1,
        customClass: "",
        delay: 0,
        fallbackPlacements: [
            "top",
            "right",
            "bottom",
            "left"
        ],
        html: !1,
        offset: [
            0,
            6
        ],
        placement: "top",
        popperConfig: null,
        sanitize: !0,
        sanitizeFn: null,
        selector: !1,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: "",
        trigger: "hover focus"
    }, an = {
        allowList: "object",
        animation: "boolean",
        boundary: "(string|element)",
        container: "(string|element|boolean)",
        customClass: "(string|function)",
        delay: "(number|object)",
        fallbackPlacements: "array",
        html: "boolean",
        offset: "(array|string|function)",
        placement: "(string|function)",
        popperConfig: "(null|object|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        selector: "(string|boolean)",
        template: "string",
        title: "(string|element|function)",
        trigger: "string"
    };
    var ln = /*#__PURE__*/ function(W) {
        _inherits(ln, W);
        var _super = _create_super(ln);
        function ln(t, e) {
            _class_call_check(this, ln);
            var _this;
            if (void 0 === Ve) throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
            _this = _super.call(this, t, e), _this._isEnabled = !0, _this._timeout = 0, _this._isHovered = null, _this._activeTrigger = {}, _this._popper = null, _this._templateFactory = null, _this._newContent = null, _this.tip = null, _this._setListeners(), _this._config.selector || _this._fixTitle();
            return _possible_constructor_return(_this);
        }
        _create_class(ln, [
            {
                key: "enable",
                value: function enable() {
                    this._isEnabled = !0;
                }
            },
            {
                key: "disable",
                value: function disable() {
                    this._isEnabled = !1;
                }
            },
            {
                key: "toggleEnabled",
                value: function toggleEnabled() {
                    this._isEnabled = !this._isEnabled;
                }
            },
            {
                key: "toggle",
                value: function toggle() {
                    this._isEnabled && (this._activeTrigger.click = !this._activeTrigger.click, this._isShown() ? this._leave() : this._enter());
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    clearTimeout(this._timeout), P.off(this._element.closest(tn), en, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), _get(_get_prototype_of(ln.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "show",
                value: function show() {
                    var _this = this;
                    var _instance;
                    if ("none" === this._element.style.display) throw new Error("Please use show on visible elements");
                    if (!this._isWithContent() || !this._isEnabled) return;
                    var t = P.trigger(this._element, this.constructor.eventName("show")), e = (c(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
                    if (t.defaultPrevented || !e) return;
                    this._disposePopper();
                    var i = this._getTipElement();
                    this._element.setAttribute("aria-describedby", i.getAttribute("id"));
                    var _this__config = this._config, n = _this__config.container;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (this._element.ownerDocument.documentElement.contains(this.tip) || (n.append(i), P.trigger(this._element, this.constructor.eventName("inserted"))), this._popper = this._createPopper(i), i.classList.add(Zi), "ontouchstart" in document.documentElement) try {
                        for(var _iterator = (_instance = []).concat.apply(_instance, _to_consumable_array(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t1 = _step.value;
                            P.on(t1, "mouseover", h);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._queueCallback(function() {
                        P.trigger(_this._element, _this.constructor.eventName("shown")), !1 === _this._isHovered && _this._leave(), _this._isHovered = !1;
                    }, this.tip, this._isAnimated());
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    if (this._isShown() && !P.trigger(this._element, this.constructor.eventName("hide")).defaultPrevented) {
                        var _instance;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (this._getTipElement().classList.remove(Zi), "ontouchstart" in document.documentElement) try {
                            for(var _iterator = (_instance = []).concat.apply(_instance, _to_consumable_array(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var t = _step.value;
                                P.off(t, "mouseover", h);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._activeTrigger.click = !1, this._activeTrigger.focus = !1, this._activeTrigger.hover = !1, this._isHovered = null, this._queueCallback(function() {
                            _this._isWithActiveTrigger() || (_this._isHovered || _this._disposePopper(), _this._element.removeAttribute("aria-describedby"), P.trigger(_this._element, _this.constructor.eventName("hidden")));
                        }, this.tip, this._isAnimated());
                    }
                }
            },
            {
                key: "update",
                value: function update() {
                    this._popper && this._popper.update();
                }
            },
            {
                key: "_isWithContent",
                value: function _isWithContent() {
                    return Boolean(this._getTitle());
                }
            },
            {
                key: "_getTipElement",
                value: function _getTipElement() {
                    return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
                }
            },
            {
                key: "_createTipElement",
                value: function _createTipElement(t) {
                    var e = this._getTemplateFactory(t).toHtml();
                    if (!e) return null;
                    e.classList.remove(Ji, Zi), e.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
                    var i = (function(t) {
                        do t += Math.floor(1e6 * Math.random());
                        while (document.getElementById(t));
                        return t;
                    })(this.constructor.NAME).toString();
                    return e.setAttribute("id", i), this._isAnimated() && e.classList.add(Ji), e;
                }
            },
            {
                key: "setContent",
                value: function setContent(t) {
                    this._newContent = t, this._isShown() && (this._disposePopper(), this.show());
                }
            },
            {
                key: "_getTemplateFactory",
                value: function _getTemplateFactory(t) {
                    return this._templateFactory ? this._templateFactory.changeContent(t) : this._templateFactory = new Ui(_object_spread_props(_object_spread({}, this._config), {
                        content: t,
                        extraClass: this._resolvePossibleFunction(this._config.customClass)
                    })), this._templateFactory;
                }
            },
            {
                key: "_getContentForTemplate",
                value: function _getContentForTemplate() {
                    return {
                        ".tooltip-inner": this._getTitle()
                    };
                }
            },
            {
                key: "_getTitle",
                value: function _getTitle() {
                    return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
                }
            },
            {
                key: "_initializeOnDelegatedTarget",
                value: function _initializeOnDelegatedTarget(t) {
                    return this.constructor.getOrCreateInstance(t.delegateTarget, this._getDelegateConfig());
                }
            },
            {
                key: "_isAnimated",
                value: function _isAnimated() {
                    return this._config.animation || this.tip && this.tip.classList.contains(Ji);
                }
            },
            {
                key: "_isShown",
                value: function _isShown() {
                    return this.tip && this.tip.classList.contains(Zi);
                }
            },
            {
                key: "_createPopper",
                value: function _createPopper(t) {
                    var e = g(this._config.placement, [
                        this,
                        t,
                        this._element
                    ]), i = on[e.toUpperCase()];
                    return qe(this._element, t, this._getPopperConfig(i));
                }
            },
            {
                key: "_getOffset",
                value: function _getOffset() {
                    var _this = this;
                    var _this__config = this._config, t = _this__config.offset;
                    return "string" == typeof t ? t.split(",").map(function(t) {
                        return Number.parseInt(t, 10);
                    }) : "function" == typeof t ? function(e) {
                        return t(e, _this._element);
                    } : t;
                }
            },
            {
                key: "_resolvePossibleFunction",
                value: function _resolvePossibleFunction(t) {
                    return g(t, [
                        this._element
                    ]);
                }
            },
            {
                key: "_getPopperConfig",
                value: function _getPopperConfig(t) {
                    var _this = this;
                    var e = {
                        placement: t,
                        modifiers: [
                            {
                                name: "flip",
                                options: {
                                    fallbackPlacements: this._config.fallbackPlacements
                                }
                            },
                            {
                                name: "offset",
                                options: {
                                    offset: this._getOffset()
                                }
                            },
                            {
                                name: "preventOverflow",
                                options: {
                                    boundary: this._config.boundary
                                }
                            },
                            {
                                name: "arrow",
                                options: {
                                    element: ".".concat(this.constructor.NAME, "-arrow")
                                }
                            },
                            {
                                name: "preSetPlacement",
                                enabled: !0,
                                phase: "beforeMain",
                                fn: function(t) {
                                    _this._getTipElement().setAttribute("data-popper-placement", t.state.placement);
                                }
                            }
                        ]
                    };
                    return _object_spread({}, e, g(this._config.popperConfig, [
                        e
                    ]));
                }
            },
            {
                key: "_setListeners",
                value: function _setListeners() {
                    var _this = this;
                    var t = this._config.trigger.split(" ");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var e = _step.value;
                            if ("click" === e) P.on(this._element, this.constructor.eventName("click"), this._config.selector, function(t) {
                                _this._initializeOnDelegatedTarget(t).toggle();
                            });
                            else if ("manual" !== e) {
                                var t1 = e === nn ? this.constructor.eventName("mouseenter") : this.constructor.eventName("focusin"), i = e === nn ? this.constructor.eventName("mouseleave") : this.constructor.eventName("focusout");
                                P.on(this._element, t1, this._config.selector, function(t) {
                                    var e = _this._initializeOnDelegatedTarget(t);
                                    e._activeTrigger["focusin" === t.type ? sn : nn] = !0, e._enter();
                                }), P.on(this._element, i, this._config.selector, function(t) {
                                    var e = _this._initializeOnDelegatedTarget(t);
                                    e._activeTrigger["focusout" === t.type ? sn : nn] = e._element.contains(t.relatedTarget), e._leave();
                                });
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._hideModalHandler = function() {
                        _this._element && _this.hide();
                    }, P.on(this._element.closest(tn), en, this._hideModalHandler);
                }
            },
            {
                key: "_fixTitle",
                value: function _fixTitle() {
                    var t = this._element.getAttribute("title");
                    t && (this._element.getAttribute("aria-label") || this._element.textContent.trim() || this._element.setAttribute("aria-label", t), this._element.setAttribute("data-bs-original-title", t), this._element.removeAttribute("title"));
                }
            },
            {
                key: "_enter",
                value: function _enter() {
                    var _this = this;
                    this._isShown() || this._isHovered ? this._isHovered = !0 : (this._isHovered = !0, this._setTimeout(function() {
                        _this._isHovered && _this.show();
                    }, this._config.delay.show));
                }
            },
            {
                key: "_leave",
                value: function _leave() {
                    var _this = this;
                    this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(function() {
                        _this._isHovered || _this.hide();
                    }, this._config.delay.hide));
                }
            },
            {
                key: "_setTimeout",
                value: function _setTimeout(t, e) {
                    clearTimeout(this._timeout), this._timeout = setTimeout(t, e);
                }
            },
            {
                key: "_isWithActiveTrigger",
                value: function _isWithActiveTrigger() {
                    return Object.values(this._activeTrigger).includes(!0);
                }
            },
            {
                key: "_getConfig",
                value: function _getConfig(t) {
                    var e = H.getDataAttributes(this._element);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step.value;
                            Gi.has(_$t) && delete e[_$t];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return t = _object_spread({}, e, "object" == typeof t && t ? t : {}), t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(t) {
                    return t.container = !1 === t.container ? document.body : r(t.container), "number" == typeof t.delay && (t.delay = {
                        show: t.delay,
                        hide: t.delay
                    }), "number" == typeof t.title && (t.title = t.title.toString()), "number" == typeof t.content && (t.content = t.content.toString()), t;
                }
            },
            {
                key: "_getDelegateConfig",
                value: function _getDelegateConfig() {
                    var t = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(this._config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _sliced_to_array(_step.value, 2), e = _step_value[0], i = _step_value[1];
                            this.constructor.Default[e] !== i && (t[e] = i);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return t.selector = !1, t.trigger = "manual", t;
                }
            },
            {
                key: "_disposePopper",
                value: function _disposePopper() {
                    this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return rn;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return an;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "tooltip";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = ln.getOrCreateInstance(this, t);
                        if ("string" == typeof t) {
                            if (void 0 === e[t]) throw new TypeError('No method named "'.concat(t, '"'));
                            e[t]();
                        }
                    });
                }
            }
        ]);
        return ln;
    }(W);
    m(ln);
    var cn = _object_spread_props(_object_spread({}, ln.Default), {
        content: "",
        offset: [
            0,
            8
        ],
        placement: "right",
        template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        trigger: "click"
    }), hn = _object_spread_props(_object_spread({}, ln.DefaultType), {
        content: "(null|string|element|function)"
    });
    var dn = /*#__PURE__*/ function(ln) {
        _inherits(dn, ln);
        var _super = _create_super(dn);
        function dn() {
            _class_call_check(this, dn);
            return _super.apply(this, arguments);
        }
        _create_class(dn, [
            {
                key: "_isWithContent",
                value: function _isWithContent() {
                    return this._getTitle() || this._getContent();
                }
            },
            {
                key: "_getContentForTemplate",
                value: function _getContentForTemplate() {
                    return {
                        ".popover-header": this._getTitle(),
                        ".popover-body": this._getContent()
                    };
                }
            },
            {
                key: "_getContent",
                value: function _getContent() {
                    return this._resolvePossibleFunction(this._config.content);
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return cn;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return hn;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "popover";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = dn.getOrCreateInstance(this, t);
                        if ("string" == typeof t) {
                            if (void 0 === e[t]) throw new TypeError('No method named "'.concat(t, '"'));
                            e[t]();
                        }
                    });
                }
            }
        ]);
        return dn;
    }(ln);
    m(dn);
    var un = "click.bs.scrollspy", fn = "active", pn = "[href]", mn = {
        offset: null,
        rootMargin: "0px 0px -25%",
        smoothScroll: !1,
        target: null,
        threshold: [
            .1,
            .5,
            1
        ]
    }, gn = {
        offset: "(number|null)",
        rootMargin: "string",
        smoothScroll: "boolean",
        target: "element",
        threshold: "array"
    };
    var _n = /*#__PURE__*/ function(W) {
        _inherits(_n, W);
        var _super = _create_super(_n);
        function _n(t, e) {
            _class_call_check(this, _n);
            var _this;
            _this = _super.call(this, t, e), _this._targetLinks = new Map, _this._observableSections = new Map, _this._rootElement = "visible" === getComputedStyle(_this._element).overflowY ? null : _this._element, _this._activeTarget = null, _this._observer = null, _this._previousScrollData = {
                visibleEntryTop: 0,
                parentScrollTop: 0
            }, _this.refresh();
            return _possible_constructor_return(_this);
        }
        _create_class(_n, [
            {
                key: "refresh",
                value: function refresh() {
                    this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._observableSections.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t = _step.value;
                            this._observer.observe(t);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this._observer.disconnect(), _get(_get_prototype_of(_n.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(t) {
                    return t.target = r(t.target) || document.body, t.rootMargin = t.offset ? "".concat(t.offset, "px 0px -30%") : t.rootMargin, "string" == typeof t.threshold && (t.threshold = t.threshold.split(",").map(function(t) {
                        return Number.parseFloat(t);
                    })), t;
                }
            },
            {
                key: "_maybeEnableSmoothScroll",
                value: function _maybeEnableSmoothScroll() {
                    var _this = this;
                    this._config.smoothScroll && (P.off(this._config.target, un), P.on(this._config.target, un, pn, function(t) {
                        var e = _this._observableSections.get(t.target.hash);
                        if (e) {
                            t.preventDefault();
                            var i = _this._rootElement || window, n = e.offsetTop - _this._element.offsetTop;
                            if (i.scrollTo) return void i.scrollTo({
                                top: n,
                                behavior: "smooth"
                            });
                            i.scrollTop = n;
                        }
                    }));
                }
            },
            {
                key: "_getNewObserver",
                value: function _getNewObserver() {
                    var _this = this;
                    var t = {
                        root: this._rootElement,
                        threshold: this._config.threshold,
                        rootMargin: this._config.rootMargin
                    };
                    return new IntersectionObserver(function(t) {
                        return _this._observerCallback(t);
                    }, t);
                }
            },
            {
                key: "_observerCallback",
                value: function _observerCallback(t) {
                    var _this = this;
                    var e = function(t) {
                        return _this._targetLinks.get("#".concat(t.target.id));
                    }, i = function(t) {
                        _this._previousScrollData.visibleEntryTop = t.target.offsetTop, _this._process(e(t));
                    }, n = (this._rootElement || document.documentElement).scrollTop, s = n >= this._previousScrollData.parentScrollTop;
                    this._previousScrollData.parentScrollTop = n;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var o = _step.value;
                            if (!o.isIntersecting) {
                                this._activeTarget = null, this._clearActiveClass(e(o));
                                continue;
                            }
                            var _$t = o.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                            if (s && _$t) {
                                if (i(o), !n) return;
                            } else s || _$t || i(o);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_initializeTargetsAndObservables",
                value: function _initializeTargetsAndObservables() {
                    this._targetLinks = new Map, this._observableSections = new Map;
                    var t = z.find(pn, this._config.target);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var e = _step.value;
                            if (!e.hash || l(e)) continue;
                            var t1 = z.findOne(decodeURI(e.hash), this._element);
                            a(t1) && (this._targetLinks.set(decodeURI(e.hash), e), this._observableSections.set(e.hash, t1));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_process",
                value: function _process(t) {
                    this._activeTarget !== t && (this._clearActiveClass(this._config.target), this._activeTarget = t, t.classList.add(fn), this._activateParents(t), P.trigger(this._element, "activate.bs.scrollspy", {
                        relatedTarget: t
                    }));
                }
            },
            {
                key: "_activateParents",
                value: function _activateParents(t) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (t.classList.contains("dropdown-item")) z.findOne(".dropdown-toggle", t.closest(".dropdown")).classList.add(fn);
                    else try {
                        for(var _iterator = z.parents(t, ".nav, .list-group")[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                            var e = _step.value;
                            try {
                                for(var _iterator1 = z.prev(e, ".nav-link, .nav-item > .nav-link, .list-group-item")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step1.value;
                                    _$t.classList.add(fn);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            },
            {
                key: "_clearActiveClass",
                value: function _clearActiveClass(t) {
                    t.classList.remove(fn);
                    var e = z.find("[href].active", t);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step.value;
                            _$t.classList.remove(fn);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return mn;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return gn;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "scrollspy";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = _n.getOrCreateInstance(this, t);
                        if ("string" == typeof t) {
                            if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError('No method named "'.concat(t, '"'));
                            e[t]();
                        }
                    });
                }
            }
        ]);
        return _n;
    }(W);
    P.on(window, "load.bs.scrollspy.data-api", function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = z.find('[data-bs-spy="scroll"]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                _n.getOrCreateInstance(t);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }), m(_n);
    var bn = "ArrowLeft", vn = "ArrowRight", yn = "ArrowUp", wn = "ArrowDown", An = "active", En = "fade", Tn = "show", Cn = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', On = '.nav-link:not(.dropdown-toggle), .list-group-item:not(.dropdown-toggle), [role="tab"]:not(.dropdown-toggle), '.concat(Cn);
    var xn = /*#__PURE__*/ function(W) {
        _inherits(xn, W);
        var _super = _create_super(xn);
        function xn(t) {
            _class_call_check(this, xn);
            var _this;
            _this = _super.call(this, t), _this._parent = _this._element.closest('.list-group, .nav, [role="tablist"]'), _this._parent && (_this._setInitialAttributes(_this._parent, _this._getChildren()), P.on(_this._element, "keydown.bs.tab", function(t) {
                return _this._keydown(t);
            }));
            return _possible_constructor_return(_this);
        }
        _create_class(xn, [
            {
                key: "show",
                value: function show() {
                    var t = this._element;
                    if (this._elemIsActive(t)) return;
                    var e = this._getActiveElem(), i = e ? P.trigger(e, "hide.bs.tab", {
                        relatedTarget: t
                    }) : null;
                    P.trigger(t, "show.bs.tab", {
                        relatedTarget: e
                    }).defaultPrevented || i && i.defaultPrevented || (this._deactivate(e, t), this._activate(t, e));
                }
            },
            {
                key: "_activate",
                value: function _activate(t, e) {
                    var _this = this;
                    t && (t.classList.add(An), this._activate(z.getElementFromSelector(t)), this._queueCallback(function() {
                        "tab" === t.getAttribute("role") ? (t.removeAttribute("tabindex"), t.setAttribute("aria-selected", !0), _this._toggleDropDown(t, !0), P.trigger(t, "shown.bs.tab", {
                            relatedTarget: e
                        })) : t.classList.add(Tn);
                    }, t, t.classList.contains(En)));
                }
            },
            {
                key: "_deactivate",
                value: function _deactivate(t, e) {
                    var _this = this;
                    t && (t.classList.remove(An), t.blur(), this._deactivate(z.getElementFromSelector(t)), this._queueCallback(function() {
                        "tab" === t.getAttribute("role") ? (t.setAttribute("aria-selected", !1), t.setAttribute("tabindex", "-1"), _this._toggleDropDown(t, !1), P.trigger(t, "hidden.bs.tab", {
                            relatedTarget: e
                        })) : t.classList.remove(Tn);
                    }, t, t.classList.contains(En)));
                }
            },
            {
                key: "_keydown",
                value: function _keydown(t) {
                    if (![
                        bn,
                        vn,
                        yn,
                        wn
                    ].includes(t.key)) return;
                    t.stopPropagation(), t.preventDefault();
                    var e = [
                        vn,
                        wn
                    ].includes(t.key), i = b(this._getChildren().filter(function(t) {
                        return !l(t);
                    }), t.target, e, !0);
                    i && (i.focus({
                        preventScroll: !0
                    }), xn.getOrCreateInstance(i).show());
                }
            },
            {
                key: "_getChildren",
                value: function _getChildren() {
                    return z.find(On, this._parent);
                }
            },
            {
                key: "_getActiveElem",
                value: function _getActiveElem() {
                    var _this = this;
                    return this._getChildren().find(function(t) {
                        return _this._elemIsActive(t);
                    }) || null;
                }
            },
            {
                key: "_setInitialAttributes",
                value: function _setInitialAttributes(t, e) {
                    this._setAttributeIfNotExists(t, "role", "tablist");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step.value;
                            this._setInitialAttributesOnChild(_$t);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_setInitialAttributesOnChild",
                value: function _setInitialAttributesOnChild(t) {
                    t = this._getInnerElement(t);
                    var e = this._elemIsActive(t), i = this._getOuterElement(t);
                    t.setAttribute("aria-selected", e), i !== t && this._setAttributeIfNotExists(i, "role", "presentation"), e || t.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(t, "role", "tab"), this._setInitialAttributesOnTargetPanel(t);
                }
            },
            {
                key: "_setInitialAttributesOnTargetPanel",
                value: function _setInitialAttributesOnTargetPanel(t) {
                    var e = z.getElementFromSelector(t);
                    e && (this._setAttributeIfNotExists(e, "role", "tabpanel"), t.id && this._setAttributeIfNotExists(e, "aria-labelledby", "".concat(t.id)));
                }
            },
            {
                key: "_toggleDropDown",
                value: function _toggleDropDown(t, e) {
                    var i = this._getOuterElement(t);
                    if (!i.classList.contains("dropdown")) return;
                    var n = function(t, n) {
                        var s = z.findOne(t, i);
                        s && s.classList.toggle(n, e);
                    };
                    n(".dropdown-toggle", An), n(".dropdown-menu", Tn), i.setAttribute("aria-expanded", e);
                }
            },
            {
                key: "_setAttributeIfNotExists",
                value: function _setAttributeIfNotExists(t, e, i) {
                    t.hasAttribute(e) || t.setAttribute(e, i);
                }
            },
            {
                key: "_elemIsActive",
                value: function _elemIsActive(t) {
                    return t.classList.contains(An);
                }
            },
            {
                key: "_getInnerElement",
                value: function _getInnerElement(t) {
                    return t.matches(On) ? t : z.findOne(On, t);
                }
            },
            {
                key: "_getOuterElement",
                value: function _getOuterElement(t) {
                    return t.closest(".nav-item, .list-group-item") || t;
                }
            }
        ], [
            {
                key: "NAME",
                get: function get() {
                    return "tab";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = xn.getOrCreateInstance(this);
                        if ("string" == typeof t) {
                            if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError('No method named "'.concat(t, '"'));
                            e[t]();
                        }
                    });
                }
            }
        ]);
        return xn;
    }(W);
    P.on(document, "click.bs.tab", Cn, function(t) {
        [
            "A",
            "AREA"
        ].includes(this.tagName) && t.preventDefault(), l(this) || xn.getOrCreateInstance(this).show();
    }), P.on(window, "load.bs.tab", function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = z.find('.active[data-bs-toggle="tab"], .active[data-bs-toggle="pill"], .active[data-bs-toggle="list"]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                xn.getOrCreateInstance(t);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }), m(xn);
    var kn = "hide", Ln = "show", Sn = "showing", Dn = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    }, In = {
        animation: !0,
        autohide: !0,
        delay: 5e3
    };
    var Nn = /*#__PURE__*/ function(W) {
        _inherits(Nn, W);
        var _super = _create_super(Nn);
        function Nn(t, e) {
            _class_call_check(this, Nn);
            var _this;
            _this = _super.call(this, t, e), _this._timeout = null, _this._hasMouseInteraction = !1, _this._hasKeyboardInteraction = !1, _this._setListeners();
            return _possible_constructor_return(_this);
        }
        _create_class(Nn, [
            {
                key: "show",
                value: function show() {
                    var _this = this;
                    P.trigger(this._element, "show.bs.toast").defaultPrevented || (this._clearTimeout(), this._config.animation && this._element.classList.add("fade"), this._element.classList.remove(kn), d(this._element), this._element.classList.add(Ln, Sn), this._queueCallback(function() {
                        _this._element.classList.remove(Sn), P.trigger(_this._element, "shown.bs.toast"), _this._maybeScheduleHide();
                    }, this._element, this._config.animation));
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    this.isShown() && (P.trigger(this._element, "hide.bs.toast").defaultPrevented || (this._element.classList.add(Sn), this._queueCallback(function() {
                        _this._element.classList.add(kn), _this._element.classList.remove(Sn, Ln), P.trigger(_this._element, "hidden.bs.toast");
                    }, this._element, this._config.animation)));
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this._clearTimeout(), this.isShown() && this._element.classList.remove(Ln), _get(_get_prototype_of(Nn.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "isShown",
                value: function isShown() {
                    return this._element.classList.contains(Ln);
                }
            },
            {
                key: "_maybeScheduleHide",
                value: function _maybeScheduleHide() {
                    var _this = this;
                    this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(function() {
                        _this.hide();
                    }, this._config.delay)));
                }
            },
            {
                key: "_onInteraction",
                value: function _onInteraction(t, e) {
                    switch(t.type){
                        case "mouseover":
                        case "mouseout":
                            this._hasMouseInteraction = e;
                            break;
                        case "focusin":
                        case "focusout":
                            this._hasKeyboardInteraction = e;
                    }
                    if (e) return void this._clearTimeout();
                    var i = t.relatedTarget;
                    this._element === i || this._element.contains(i) || this._maybeScheduleHide();
                }
            },
            {
                key: "_setListeners",
                value: function _setListeners() {
                    var _this = this;
                    P.on(this._element, "mouseover.bs.toast", function(t) {
                        return _this._onInteraction(t, !0);
                    }), P.on(this._element, "mouseout.bs.toast", function(t) {
                        return _this._onInteraction(t, !1);
                    }), P.on(this._element, "focusin.bs.toast", function(t) {
                        return _this._onInteraction(t, !0);
                    }), P.on(this._element, "focusout.bs.toast", function(t) {
                        return _this._onInteraction(t, !1);
                    });
                }
            },
            {
                key: "_clearTimeout",
                value: function _clearTimeout() {
                    clearTimeout(this._timeout), this._timeout = null;
                }
            }
        ], [
            {
                key: "Default",
                get: function get() {
                    return In;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return Dn;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return "toast";
                }
            },
            {
                key: "jQueryInterface",
                value: function jQueryInterface(t) {
                    return this.each(function() {
                        var e = Nn.getOrCreateInstance(this, t);
                        if ("string" == typeof t) {
                            if (void 0 === e[t]) throw new TypeError('No method named "'.concat(t, '"'));
                            e[t](this);
                        }
                    });
                }
            }
        ]);
        return Nn;
    }(W);
    return R(Nn), m(Nn), {
        Alert: q,
        Button: K,
        Carousel: rt,
        Collapse: ft,
        Dropdown: ci,
        Modal: Ni,
        Offcanvas: zi,
        Popover: dn,
        ScrollSpy: _n,
        Tab: xn,
        Toast: Nn,
        Tooltip: ln
    };
}); //# sourceMappingURL=bootstrap.bundle.min.js.map

//# sourceMappingURL=index.d564fdfe.js.map
